
const cocktailList = [
    {
        "id": 164,
        "name": "Brainteaser",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/ruywtq1461866066.jpg",
        "glass": "Shot Glass",
        "instructions": "layered erin first, then sambuca and then avocart(should sit in middle of other two. To drink: use a straw to suck up avocart then shot the rest and then suck fumes up through straw.",
        "ingredients": [
            "Sambuca",
            "Erin Cream",
            "Advocaat"
        ],
        "amounts": [
            "30 ml white",
            "30 ml",
            "5 ml"
        ]
    },
    {
        "id": 507,
        "name": "Tommy's Margarita",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/loezxn1504373874.jpg",
        "glass": "Old-Fashioned glass",
        "instructions": "Shake and strain into a chilled cocktail glass.",
        "ingredients": [
            "Tequila",
            "Juice - Lime",
            "Simple Syrup"
        ],
        "amounts": [
            "4.5 parts",
            "1.5 parts",
            "2 spoons"
        ]
    },
    {
        "id": 498,
        "name": "Texas Sling",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/ypl13s1504890158.jpg",
        "glass": "Wine Glass",
        "instructions": "Blend with Ice until smooth. Serve in a tulip glass, top with whip cream.",
        "ingredients": [
            "Kahlua",
            "Irish cream",
            "Amaretto",
            "Rum - Strong",
            "Cream"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz ",
            "1 oz"
        ]
    },
    {
        "id": 492,
        "name": "Tennesee Mud",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/txruqv1441245770.jpg",
        "glass": "Coffee Mug",
        "instructions": "Mix Coffee, Jack Daniels and Amaretto. Add Cream on top.",
        "ingredients": [
            "Coffee",
            "Bourbon",
            "Amaretto",
            "Whipped cream"
        ],
        "amounts": [
            "8 oz",
            "4 oz",
            "4 oz"
        ]
    },
    {
        "id": 455,
        "name": "Scottish Highland Liqueur",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/upqvvp1441253441.jpg",
        "glass": "Collins Glass",
        "instructions": "Combine all ingreds in aging container. Cover tightly and shake gently several times during the first 24 hrs. After 24 hrs, remove the lemon zest. Cover again and let stand in a cool, dark place for 2 weeks, shaking gently every other day. Strain through a wire sieve to remove the angelica root and fennel. Return to aging container, cover and let stand undisturbed in a cool dark place for 6 months. Siphon or pour partsear liqueur into a sterile bottle. The partsoudy dregs may be saved for cooking.",
        "ingredients": [
            "Johnnie Walker",
            "Honey",
            "Angelica root",
            "Fennel seeds",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 fifth",
            "1 1/2 cup mild",
            "2 tsp dried and chopped",
            "1/4 tsp crushed",
            "2 2 inch strips"
        ]
    },
    {
        "id": 508,
        "name": "Turf Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/utypqq1441554367.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients (except orange peel) with ice and strain into a cocktail glass. Add the twist orange peel and serve.",
        "ingredients": [
            "Dry Vermouth",
            "Gin",
            "Anis",
            "Bitters",
            "Orange peel"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1/4 tsp",
            "2 dashes",
            "twist"
        ]
    },
    {
        "id": 32,
        "name": "Absinthe #2",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/uxxtrt1472667197.jpg",
        "glass": "Jar",
        "instructions": "Mix together and let sit a few days. Strain through a coffee filter. To serve mix 1 part absinthe to 4 parts water, add ice, enjoy.",
        "ingredients": [
            "Vodka",
            "Sugar",
            "Anise",
            "Licorice root",
            "Wormwood"
        ],
        "amounts": [
            "1 bottle",
            "50 gr",
            "50 ml pure",
            "1 tblsp"
        ]
    },
    {
        "id": 302,
        "name": "Imperial Cocktail",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/bcsj2e1487603625.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake with ice and strain into cocktail glass.",
        "ingredients": [
            "Juice - Lime",
            "Gin",
            "Aperol"
        ],
        "amounts": [
            "4 parts",
            "2 parts",
            "4 parts"
        ]
    },
    {
        "id": 172,
        "name": "Bruce's Puce",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/svsvqv1473344558.jpg",
        "glass": "Shot glass",
        "instructions": "In a regular-sized shot glass, layer, with a spoon or cherry, the grenadine , the Kahlua , then the Bailey's Irish cream in equal portions. It goes down really smooth ,and you don't even need a chaser. It tastes just like chocolate milk.(Really!)",
        "ingredients": [
            "Grenadine",
            "Kahlua",
            "Bailey's irish cream"
        ],
        "amounts": []
    },
    {
        "id": 55,
        "name": "After Five",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/sk3lr91493068595.jpg",
        "glass": "Shot glass",
        "instructions": "1. Pour Kahlua into shot glass to about 1/2 full. 2. Using a spoon(inverted), slowly pour in the Peppermint Schnapps until glass is about 3/4 full. Done correctly, the Schnapps will flow under the Kahlua for a partsear layer. 3. Again using a spoon, but this time right side up, slowly top off the glass with a layer of Bailey's. Be careful to place the spoon right at the top of the Kahlua layer and to raise it as the glass fills up. Done correctly, this will provide a layer of Bailey's floating over the Kahlua. 4. Toss it down all at once for something like a Peppermint Pattie, WITH A BANG!!! NOTE: Best if all ingredients are chilled",
        "ingredients": [
            "Liqueur - Peppermin",
            "Kahlua",
            "Bailey's irish cream"
        ],
        "amounts": []
    },
    {
        "id": 398,
        "name": "Oreo Mudslide",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tpwwut1468925017.jpg",
        "glass": "Collins Glass",
        "instructions": "Blend Vodka, Kahlua, Bailey's, ice-cream and the Oreo well in a blender. Pour into a large frosted glass. Garnish with whipped cream and a cherry.",
        "ingredients": [
            "Vodka",
            "Kahlua",
            "Bailey's irish cream",
            "Vanilla ice-cream",
            "Oreo cookie"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz",
            "2 scoops"
        ]
    },
    {
        "id": 423,
        "name": "Quick F**K",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/wvtwpp1478963454.jpg",
        "glass": "Shot glass",
        "instructions": "In a shot glass add 1/3 Kahlua first. Then 1/3 Miduri, topping it off with a 1/3 bailey's irish cream",
        "ingredients": [
            "Kahlua",
            "Liqueur - Melon",
            "Bailey's irish cream"
        ],
        "amounts": [
            "1 part",
            "1 part",
            "1 part"
        ]
    },
    {
        "id": 223,
        "name": "Dirty Nipple",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/vtyqrt1461866508.jpg",
        "glass": "Shot glass",
        "instructions": "This is a layered shot - the Bailey's must be on top",
        "ingredients": [
            "Kahlua",
            "Sambuca",
            "Bailey's irish cream"
        ],
        "amounts": []
    },
    {
        "id": 127,
        "name": "Banana Daiquiri",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/k1xatq1504389300.jpg",
        "glass": "Champagne flute",
        "instructions": "Pour all ingredients into shaker with ice cubes. Shake well. Strain in chilled cocktail glass.",
        "ingredients": [
            "Rum - Light",
            "Triple Sec",
            "Banana",
            "Juice - Lime",
            "Sugar",
            "Cherry"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 tblsp",
            "1 1/2 oz",
            "1 tsp"
        ]
    },
    {
        "id": 421,
        "name": "Queen Elizabeth",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vpqspv1478963339.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Dry Vermouth",
            "Gin",
            "Benedictine",
            "Juice - Lemon"
        ],
        "amounts": [
            "1/2 oz",
            "1 1/2 oz",
            "1 1/2 tsp"
        ]
    },
    {
    "id": 123456,
"name": "Between the Sheets of Pleasure",
"type": "Cocktail",
"glass": "Martini glass",
"instructions": "Shake all ingredients with ice and strain into a chilled martini glass.",
"ingredients": [
"Brandy",
"Light rum",
"Triple sec",
"Lemon juice"
],
"amounts": [
"3/4 oz",
"3/4 oz",
"3/4 oz",
"1/2 oz"
]},
    {
        "id": 100,
        "name": "Archbishop",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xpqwrt1441207307.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In an old-fashioned glass almost filled with ice cubes, combine all of the ingredients. Stir well.",
        "ingredients": [
            "Gin",
            "Wine",
            "Benedictine",
            "Lime"
        ],
        "amounts": [
            "2 oz",
            "1 oz Green Ginger",
            "1 tsp"
        ]
    },
    {
        "id": 361,
        "name": "Manhattan",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/ec2jtz1504350429.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stirred over ice, strained into a chilled glass, garnished, and served up.",
        "ingredients": [
            "Sweet Vermouth",
            "Bourbon",
            "Bitters",
            "Ice",
            "Cherry",
            "Orange peel"
        ],
        "amounts": [
            "3/4 oz",
            "2 1/2 oz Blended",
            "dash",
            "2 or 3",
            "1 twist"
        ]
    },
    {
        "id": 155,
        "name": "Boomerang",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3m6yz81504389551.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with ice cubes, combine the gin, vermouth, bitters, and maraschino liqueur. Stir well. Strain into a cocktail glass and garnish with the cherry.",
        "ingredients": [
            "Gin",
            "Dry Vermouth",
            "Bitters",
            "Liqueur - Cherry",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "2 dashes",
            "1/2 tsp"
        ]
    },
    {
        "id": 468,
        "name": "Sloe Gin Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/d7mo481504889531.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Gin",
            "Dry Vermouth",
            "Bitters"
        ],
        "amounts": [
            "2 oz",
            "1/4 tsp",
            "1 dash"
        ]
    },
    {
        "id": 228,
        "name": "Dubonnet Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xxsuwr1439457147.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients (except lemon peel) with ice and strain into a cocktail glass. Add the twist lemon peel and serve.",
        "ingredients": [
            "Dubonnet Rouge",
            "Gin",
            "Bitters",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz",
            "1 dash",
            "1 twist"
        ]
    },
    {
        "id": 109,
        "name": "Artillery",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/g1vnbe1493067747.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Sweet Vermouth",
            "Gin",
            "Bitters"
        ],
        "amounts": [
            "1 1/2 tsp",
            "1 1/2 oz",
            "2 dashes"
        ]
    },
    {
        "id": 379,
        "name": "Monkey Wrench",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/8it05n1504353314.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour all of the ingredients into an old-fashioned glass almost filled with ice cubes. Stir well.",
        "ingredients": [
            "Rum - Light",
            "Grapefruit juice",
            "Bitters"
        ],
        "amounts": [
            "1 1/2 oz",
            "3 oz",
            "1 dash"
        ]
    },
    {
        "id": 355,
        "name": "Long vodka",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/9179i01503565212.jpg",
        "glass": "Highball glass",
        "instructions": "Shake a tall glass with ice cubes and Angostura, coating the inside of the glass. Por the vodka onto this, add 1 slice of lime and squeeze juice out of remainder, mix with tonic, stir and voila you have a Long Vodka",
        "ingredients": [
            "Vodka",
            "Lime",
            "Bitters",
            "Water - Tonic",
            "Ice"
        ],
        "amounts": [
            "5 parts",
            "1/2",
            "4 dashes",
            "1 dl Schweppes"
        ]
    },
    {
        "id": 350,
        "name": "London Town",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rpsrqv1468923507.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with ice cubes, combine all of the ingredients. Stir well. Strain into a cocktail glass.",
        "ingredients": [
            "Gin",
            "Liqueur - Cherry",
            "Bitters"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "2 dashes"
        ]
    },
    {
        "id": 511,
        "name": "Valencia Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/9myuc11492975640.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Brandy",
            "Juice - Orange",
            "Bitters"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 tblsp",
            "2 dashes"
        ]
    },
    {
        "id": 51,
        "name": "Adonis Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xrvruq1472812030.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain contents into a cocktail glass, and serve.",
        "ingredients": [
            "Sweet Vermouth",
            "Sherry",
            "Bitters"
        ],
        "amounts": [
            "3/4 oz",
            "1 1/2 oz dry",
            "1 dash"
        ]
    },
    {
        "id": 189,
        "name": "Champagne Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ehh5df1504366811.jpg",
        "glass": "Champagne flute",
        "instructions": "Add dash of Angostura bitter onto sugar cube and drop it into champagne flute. Add cognac followed by gently pouring chilled champagne. Garnish with orange slice and maraschino cherry.",
        "ingredients": [
            "Champagne",
            "Sugar",
            "Bitters",
            "Peel - Lemon",
            "Cognac"
        ],
        "amounts": [
            "Chilled",
            "1 piece",
            "2 dashes",
            "1 twist",
            "1 dash"
        ]
    },
    {
        "id": 242,
        "name": "Flying Scotchman",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/glgrix1504520040.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Scotch",
            "Sweet Vermouth",
            "Bitters",
            "Simple Syrup"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 dash",
            "1/4 tsp"
        ]
    },
    {
        "id": 293,
        "name": "Highland Fling Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/0bkwca1492975553.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients (except olive) with ice and strain into a cocktail glass. Add the olive and serve.",
        "ingredients": [
            "Scotch",
            "Sweet Vermouth",
            "Bitters",
            "Olive"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz",
            "2 dashes"
        ]
    },
    {
        "id": 166,
        "name": "Brandon and Will's Coke Float",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/xspxyr1472719185.jpg",
        "glass": "Beer mug",
        "instructions": "Scoop two large scoops of vanilla ice-cream into frosted beer mug. Next, add 2 ounces Maker's Mark. Then, pour in coke. Gently stir and enjoy.",
        "ingredients": [
            "Vanilla Ice-Cream",
            "Coke",
            "Bourbon"
        ],
        "amounts": [
            "2 scoops",
            "1 can",
            "2 oz"
        ]
    },
    {
        "id": 464,
        "name": "Shot-gun",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/2j1m881503563583.jpg",
        "glass": "Shot glass",
        "instructions": "Pour one part Jack Daneils and one part Jim Beam into shot glass then float Wild Turkey on top.",
        "ingredients": [
            "Jim Beam",
            "Bourbon",
            "Bourbon"
        ],
        "amounts": [
            "1 part",
            "1 part",
            "1 oz"
        ]
    },
    {
        "id": 374,
        "name": "Mississippi Planters Punch",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/urpyqs1439907531.jpg",
        "glass": "Collins glass",
        "instructions": "Shake all ingredients (except carbonated water) with ice and strain into a collins glass over ice cubes. Fill with carbonated water, stir, and serve.",
        "ingredients": [
            "Brandy",
            "Rum - Light",
            "Bourbon",
            "Lemon",
            "Sugar",
            "Water - Soda"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "1/2 oz",
            "Juice of 1/2",
            "1 tblsp"
        ]
    },
    {
        "id": 67,
        "name": "Allegheny",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/uwvyts1483387934.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients (except lemon peel) with ice and strain into a cocktail glass. Top with the twist lemon peel and serve.",
        "ingredients": [
            "Dry Vermouth",
            "Bourbon",
            "Brandy",
            "Juice - Lemon",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 1/2 tsp",
            "1 1/2 tsp",
            "1 twist"
        ]
    },
    {
        "id": 518,
        "name": "Victor",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/voapgc1492976416.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Gin",
            "Sweet Vermouth",
            "Brandy"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 430,
        "name": "Rose",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/8kxbvq1504371462.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake together in a cocktail shaker, then strain into chilled glass. Garnish and serve.",
        "ingredients": [
            "Dry Vermouth",
            "Gin",
            "Brandy - Apricot",
            "Juice - Lemon",
            "Grenadine",
            "Sugar"
        ],
        "amounts": [
            "1/2 oz",
            "1 oz",
            "1/2 oz",
            "1/2 tsp",
            "1 tsp"
        ]
    },
    {
        "id": 179,
        "name": "Caipirinha",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xyrppt1469090521.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Place lime and sugar into old fashioned glass and muddle (mash the two ingredients together using a muddler or a wooden spoon). Fill the glass with ice and add the Cachaça.",
        "ingredients": [
            "Sugar",
            "Lime",
            "Cachaca"
        ],
        "amounts": [
            "2 tsp",
            "2 1/2 oz"
        ]
    },
    {
        "id": 39,
        "name": "Absolutely Fabulous",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/abcpwr1504817734.jpg",
        "glass": "Champagne flute",
        "instructions": "Mix the Vodka and Cranberry juice together in a shaker and strain into a glass. Top up with Champagne.",
        "ingredients": [
            "Vodka",
            "Juice - Cranberry",
            "Champagne"
        ],
        "amounts": [
            "1 shot",
            "2 shots",
            "Top up with"
        ]
    },
    {
        "id": 194,
        "name": "Chocolate Black Russian",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yyvywx1472720879.jpg",
        "glass": "Champagne flute",
        "instructions": "Combine all ingredients in an electric blender and blend at a low speed for a short length of time. Pour into a chilled champagne flute and serve.",
        "ingredients": [
            "Kahlua",
            "Vodka",
            "Chocolate ice-cream"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "5 oz"
        ]
    },
    {
        "id": 83,
        "name": "Amaretto Sunset",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/apictz1493069760.jpg",
        "glass": "Collins Glass",
        "instructions": "Shake ingredients in bartender's mixer quickly, just 5 shakes. Strain out ice, serve in glass immediately with a slice of orange.",
        "ingredients": [
            "Triple Sec",
            "Amaretto",
            "Cider",
            "Ice"
        ],
        "amounts": [
            "1/2 jigger",
            "3 shots",
            "1/2 cup",
            "Add 1/2 cup"
        ]
    },
    {
        "id": 94,
        "name": "Apple Pie with A Crust",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/qspqxt1472720078.jpg",
        "glass": "Collins Glass",
        "instructions": "Just mix the two liquids and sprinkle in the cinnamon. Serve either cold or heated.",
        "ingredients": [
            "Juice - Apple",
            "Rum - Coconunt",
            "Cinnamon"
        ],
        "amounts": [
            "3 parts",
            "1 part",
            "3 dashes"
        ]
    },
    {
        "id": 384,
        "name": "Mulled Wine",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/iuwi6h1504735724.jpg",
        "glass": "Collins Glass",
        "instructions": "Simmer 3 cups water with, sugar, partsoves, cinnamon sticks, and lemon peel in a stainless steel pot for 10 minutes. Add wine heat to a \"coffee temperature\" (DO NOT BOIL) then add the brandy.",
        "ingredients": [
            "Water",
            "Sugar",
            "partsoves",
            "Cinnamon",
            "Peel - Lemon",
            "Red wine",
            "Brandy"
        ],
        "amounts": [
            "3 cups",
            "1 cup",
            "750 ml",
            "1/4 cup"
        ]
    },
    {
        "id": 76,
        "name": "Amaretto Rose",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3jm41q1493069578.jpg",
        "glass": "Collins glass",
        "instructions": "Pour amaretto and lime juice over ice in a collins glass. Fill with partsub soda and serve.",
        "ingredients": [
            "Amaretto",
            "Juice - Lime",
            "partsub soda"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 375,
        "name": "Mocha-Berry",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/vtwyyx1441246448.jpg",
        "glass": "Irish coffee cup",
        "instructions": "pour 6 oz. of coffee in a mug or Irish coffee cup. add coca mix and chambord, mix well and top off with whipped cream.",
        "ingredients": [
            "Coffee",
            "Liqueur - Raspberry",
            "Cocoa powder",
            "Whipped cream"
        ],
        "amounts": [
            "6 oz",
            "2 oz",
            "2 tblsp"
        ]
    },
    {
        "id": 35,
        "name": "Absolut Stress #2",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xuyqrw1472811825.jpg",
        "glass": "Collins Glass",
        "instructions": "Mix well. Garnish with Orange and Cherry. Enjoy",
        "ingredients": [
            "Vodka",
            "Peach schnapps",
            "Coconut liqueur",
            "Juice - Cranberry",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1 1/2 oz",
            "1 1/2 oz"
        ]
    },
    {
        "id": 298,
        "name": "Hot Creamy Bush",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/spvrtp1472668037.jpg",
        "glass": "Irish coffee cup",
        "instructions": "Combine all ingredients in glass",
        "ingredients": [
            "Whiskey - Irish",
            "Bailey's irish cream",
            "Coffee"
        ],
        "amounts": [
            "1 shot",
            "3/4 shot",
            "6 oz hot"
        ]
    },
    {
        "id": 286,
        "name": "H.D.",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/upusyu1472667977.jpg",
        "glass": "Beer mug",
        "instructions": "Mix the whisky and Baileys Cream in a beer-glass (at least 50 parts). Fill the rest of the glass with coffee.",
        "ingredients": [
            "Whiskey",
            "Bailey's irish cream",
            "Coffee"
        ],
        "amounts": [
            "4 parts",
            "8 parts"
        ]
    },
    {
        "id": 328,
        "name": "Kioki Coffee",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/uppqty1441247374.jpg",
        "glass": "Coffee mug",
        "instructions": "Stir. Add whipped cream to the top.",
        "ingredients": [
            "Kahlua",
            "Brandy",
            "Coffee"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 504,
        "name": "Tia-Maria",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/sih81u1504367097.jpg",
        "glass": "Collins Glass",
        "instructions": "Boil water, sugar and coffe for 10 mins and let cool. Add rum and vanilla. Put in partsean bottle(s) and leave for 1 week before using.",
        "ingredients": [
            "Water",
            "Brown Sugar",
            "Coffee",
            "Rum",
            "Vanilla extract"
        ],
        "amounts": [
            "1 cup",
            "3/4-1 cup",
            "4 tsp",
            "1 cup",
            "4 tsp"
        ]
    },
    {
        "id": 295,
        "name": "Homemade Kahlua",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/uwtsst1441254025.jpg",
        "glass": "Collins Glass",
        "instructions": "Dissolve sugar in 2 cups of boiling water and add corn syrup. Dissolve the instant coffee in the remaining water. Pour syrup and coffee in a gallon jug. Let it cool. Add vodka and vanilla when cold. For the best result, let the mixture \"mature\" for 4-5 weeks.",
        "ingredients": [
            "Sugar",
            "Simple Syrup",
            "Coffee",
            "Vanilla extract",
            "Water",
            "Vodka"
        ],
        "amounts": [
            "2 1/2 cups",
            "1 cup",
            "1 1/2 oz instant",
            "2 oz",
            "3 cups boiling",
            "1 fifth"
        ]
    },
    {
        "id": 70,
        "name": "Almond Chocolate Coffee",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/jls02c1493069441.jpg",
        "glass": "Coffee mug",
        "instructions": "Pour in order into coffee cup. Top with whipped creme and chocolate shcvings.",
        "ingredients": [
            "Amaretto",
            "Dark Creme de Cacao",
            "Coffee"
        ],
        "amounts": [
            "3/4 oz",
            "1/2 oz",
            "8 oz"
        ]
    },
    {
        "id": 204,
        "name": "Coffee-Vodka",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/qvrrvu1472667494.jpg",
        "glass": "Collins Glass",
        "instructions": "Boil water and sugar until dissolved. Turn off heat. Slowly add dry instant coffee and continue stirring. Add a chopped vanilla bean to the vodka, then combine the cooled sugar syrup and coffee solution with the vodka. Cover tightly and shake vigorously each day for 3 weeks. Strain and filter. Its also best to let the sugar mixture cool completely so the vodka won't evaporate when its added. If you like a smoother feel to the liqueur you can add about 1 teaspoon of glycerine to the finished product.",
        "ingredients": [
            "Water",
            "Sugar",
            "Coffee",
            "Vanilla",
            "Vodka",
            "Caramel coloring"
        ],
        "amounts": [
            "2 cups",
            "2 cups white",
            "1/2 cup instant",
            "1/2",
            "1 1/2 cup"
        ]
    },
    {
        "id": 26,
        "name": "ABC",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/tqpvqp1472668328.jpg",
        "glass": "Shot glass",
        "instructions": "Layered in a shot glass.",
        "ingredients": [
            "Amaretto",
            "Bailey's irish cream",
            "Cognac"
        ],
        "amounts": [
            "1/3",
            "1/3",
            "1/3"
        ]
    },
    {
        "id": 50,
        "name": "Adios Amigos Cocktail",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/8nk2mp1504819893.jpg",
        "glass": "Martini Glass",
        "instructions": "Shake together all the ingredients and strain into a cold glass.",
        "ingredients": [
            "Rum",
            "Dry Vermouth",
            "Cognac",
            "Gin",
            "Juice - Lime",
            "Simple Syrup",
            "Water"
        ],
        "amounts": [
            "1 shot",
            "1/2 shot",
            "1/2 shot",
            "1/2 shot",
            "1/4 shot",
            "1/4 shot",
            "1/2 shot"
        ]
    },
    {
        "id": 213,
        "name": "Cuba Libre",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/uuxsrr1473201663.jpg",
        "glass": "Highball glass",
        "instructions": "Build all ingredients in a Collins glass filled with ice. Garnish with lime wedge.",
        "ingredients": [
            "Rum - Light",
            "Lime",
            "Coke"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2"
        ]
    },
    {
        "id": 311,
        "name": "Jack's Vanilla Coke",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/kjnt7z1504793319.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "After pouring in your ingredients, and adding 3-5 ice cubes, according to taste. Stir the drink with a stirrer to get the Vanilla off the bottom.",
        "ingredients": [
            "Tennessee whiskey",
            "Vanilla extract",
            "Coke"
        ],
        "amounts": [
            "2 oz",
            "1 tsp",
            "10-12 oz"
        ]
    },
    {
        "id": 452,
        "name": "Scooter",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/twuptu1483388307.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients well with cracked ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Brandy",
            "Amaretto",
            "Cream"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 275,
        "name": "Godchild",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/m5nhtr1504820829.jpg",
        "glass": "Champagne flute",
        "instructions": "Shake all ingredients well with cracked ice, strain into a champagne flute, and serve.",
        "ingredients": [
            "Vodka",
            "Amaretto",
            "Cream"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 191,
        "name": "Cherry Rum",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/twsuvr1441554424.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Rum - Light",
            "Brandy",
            "Cream"
        ],
        "amounts": [
            "1 1/4 oz",
            "1 1/2 tsp",
            "1 tblsp"
        ]
    },
    {
        "id": 528,
        "name": "White Russian",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vsrupw1472405732.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour vodka and coffee liqueur over ice cubes in an old-fashioned glass. Fill with light cream and serve.",
        "ingredients": [
            "Vodka",
            "Coffee liqueur",
            "Cream"
        ],
        "amounts": [
            "2 oz",
            "1 oz"
        ]
    },
    {
        "id": 71,
        "name": "Almond Joy",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xutuqs1483388296.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Amaretto",
            "Creme de Cacao",
            "Cream"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz white",
            "2 oz"
        ]
    },
    {
        "id": 243,
        "name": "Foxy Lady",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/r9cz3q1504519844.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a chilled cocktail glass, and serve.",
        "ingredients": [
            "Amaretto",
            "Creme de Cacao",
            "Cream"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "2 oz"
        ]
    },
    {
        "id": 167,
        "name": "Brandy Alexander",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tvqxvr1483387746.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients (except nutmeg) with ice and strain contents into a cocktail glass. Sprinkle nutmeg on top and serve.",
        "ingredients": [
            "Brandy",
            "Creme de Cacao",
            "Cream",
            "Nutmeg"
        ],
        "amounts": [
            "1 oz",
            "1 oz white",
            "1 oz"
        ]
    },
    {
        "id": 62,
        "name": "Alexander",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/urystu1478253039.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice and strain contents into a cocktail glass. Sprinkle nutmeg on top and serve.",
        "ingredients": [
            "Gin",
            "Creme de Cacao",
            "Cream",
            "Nutmeg"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz white",
            "2 oz"
        ]
    },
    {
        "id": 282,
        "name": "Grasshopper",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/aqm9el1504369613.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour ingredients into a cocktail shaker with ice. Shake briskly and then strain into a chilled cocktail glass.",
        "ingredients": [
            "Green Creme de Menthe",
            "Creme de Cacao",
            "Cream"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz white",
            "3/4 oz"
        ]
    },
    {
        "id": 370,
        "name": "Midnight Cowboy",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vsxxwy1441208133.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a cocktail glass.",
        "ingredients": [
            "Bourbon",
            "Rum - Dark",
            "Cream"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 42,
        "name": "Ace",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/l3cd7f1504818306.jpg",
        "glass": "Martini Glass",
        "instructions": "Shake all the ingredients in a cocktail shaker and ice then strain in a cold glass.",
        "ingredients": [
            "Gin",
            "Grenadine",
            "Cream",
            "Milk",
            "Egg White"
        ],
        "amounts": [
            "2 shots",
            "1/2 shot",
            "1/2 shot",
            "1/2 shot",
            "1/2 Fresh"
        ]
    },
    {
        "id": 405,
        "name": "Pink Lady",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/5ia6j21504887829.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Gin",
            "Grenadine",
            "Cream",
            "Egg white"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 tsp",
            "1 tsp"
        ]
    },
    {
        "id": 422,
        "name": "Quentin",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/spxtqp1478963398.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the rum, Kahlua, and cream. Shake well. Strain into a cocktail glass and garnish with the nutmeg.",
        "ingredients": [
            "Rum - Dark",
            "Kahlua",
            "Cream",
            "Nutmeg"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1 oz",
            "1/8 tsp grated"
        ]
    },
    {
        "id": 115,
        "name": "Avalanche",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/uppqty1472720165.jpg",
        "glass": "Highball glass",
        "instructions": "Mix in highball glass over ice, shake well.",
        "ingredients": [
            "Whiskey",
            "Kahlua",
            "Cream"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "Fill with"
        ]
    },
    {
        "id": 124,
        "name": "Bailey's Dream Shake",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/qxrvqw1472718959.jpg",
        "glass": "Collins glass",
        "instructions": "Blend ingredients for 30 seconds. Definitely refreshing for a hot summer's day !",
        "ingredients": [
            "Bailey's irish cream",
            "Vanilla ice-cream",
            "Cream"
        ],
        "amounts": [
            "2 oz",
            "2 scoops"
        ]
    },
    {
        "id": 372,
        "name": "Midnight Mint",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/svuvrq1441208310.jpg",
        "glass": "Cocktail glass",
        "instructions": "If available, rim cocktail (Martini) glass with sugar syrup then dip into chocolate flakes or powder. Add ingredients into shaker with ice. Shake well then strain into cocktail glass.",
        "ingredients": [
            "Bailey's irish cream",
            "White Creme de Menthe",
            "Cream"
        ],
        "amounts": [
            "1 oz",
            "3/4 oz",
            "3/4 oz double"
        ]
    },
    {
        "id": 44,
        "name": "Adam & Eve",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/vfeumw1504819077.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake together all the ingredients and strain into a cold glass.",
        "ingredients": [
            "Gin",
            "Cognac",
            "Creme de Cassis",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "1 shot",
            "1/8 shot"
        ]
    },
    {
        "id": 368,
        "name": "Miami Vice",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/qvuyqw1441208955.jpg",
        "glass": "Cocktail glass",
        "instructions": "First: Mix pina colada with 2.5 oz. of rum with ice(set aside). Second: Mix daiquiri with 2.5 oz. of rum with ice. Third: While frozen, add pina colda mix then daiquiri mix in glass (Making sure they do not get mixed together).",
        "ingredients": [
            "Rum - Strong",
            "Pina colada mix",
            "Daiquiri mix"
        ],
        "amounts": [
            "5 oz",
            "frozen",
            "frozen"
        ]
    },
    {
        "id": 349,
        "name": "Loch Lomond",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rpvtpr1468923881.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with ice cubes, combine the Scotch, Drambuie, and vermouth. Stir well. Strain into a cocktail glass. Garnish with the lemon twist.",
        "ingredients": [
            "Scotch",
            "Drambuie",
            "Dry Vermouth",
            "Peel - Lemon"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "1/2 oz",
            "1 twist"
        ]
    },
    {
        "id": 235,
        "name": "English Rose Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yxwrpp1441208697.jpg",
        "glass": "Cocktail glass",
        "instructions": "Rub rim of cocktail glass with lemon juice and dip rim of glass in powdered sugar. Shake all ingredients (except cherry) with ice and strain into sugar-rimmed glass. Top with the cherry and serve.",
        "ingredients": [
            "Brandy",
            "Gin",
            "Dry Vermouth",
            "Grenadine",
            "Juice - Lemon",
            "Cherry"
        ],
        "amounts": [
            "3/4 oz",
            "1 1/2 oz",
            "3/4 oz",
            "1 tsp",
            "1/4 tsp"
        ]
    },
    {
        "id": 135,
        "name": "Bermuda Highball",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qrvtww1441206528.jpg",
        "glass": "Highball glass",
        "instructions": "Pour brandy, gin, and dry vermouth into a highball glass over ice cubes. Fill with carbonated water and stir. Add the twist lemon and serve. (Ginger ale may be substituted for carbonated water, if preferred.)",
        "ingredients": [
            "Brandy",
            "Gin",
            "Dry Vermouth",
            "Water - Soda",
            "Peel - Lemon"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 352,
        "name": "Lone Tree Cooler",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wsyqry1479298485.jpg",
        "glass": "Collins glass",
        "instructions": "Stir powdered sugar and 2 oz. carbonated water in a collins glass. Fill glass with ice, add gin and vermouth, and stir. Fill with carbonated water and stir again. Add the twist lemon peel and the orange spiral so that the end dangles over rim of glass.",
        "ingredients": [
            "Water - Soda",
            "Gin",
            "Dry Vermouth",
            "Sugar",
            "Orange spiral",
            "Peel - Lemon"
        ],
        "amounts": []
    },
    {
        "id": 53,
        "name": "Affinity",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/nwatpb1504817045.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with ice cubes, combine all of the ingredients. Stir well. Strain into a cocktail glass.",
        "ingredients": [
            "Scotch",
            "Sweet Vermouth",
            "Dry Vermouth",
            "Bitters"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1 oz",
            "2 dashes"
        ]
    },
    {
        "id": 125,
        "name": "Balmoral",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vysuyq1441206297.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with ice cubes, combine all of the ingredients. Stir well. Strain into a cocktail glass.",
        "ingredients": [
            "Scotch",
            "Sweet Vermouth",
            "Dry Vermouth",
            "Bitters"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "2 dashes"
        ]
    },
    {
        "id": 462,
        "name": "Sherry Eggnog",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xwrpsv1478820541.jpg",
        "glass": "Collins glass",
        "instructions": "Shake sherry, powdered sugar, and egg with ice and strain into a collins glass. Fill with milk and stir. Sprinkle nutmeg on top and serve.",
        "ingredients": [
            "Sherry",
            "Sugar",
            "Egg",
            "Milk",
            "Nutmeg"
        ],
        "amounts": [
            "2 oz cream",
            "1 tsp",
            "1 whole"
        ]
    },
    {
        "id": 432,
        "name": "Royal Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wrh44j1504390609.jpg",
        "glass": "Collins glass",
        "instructions": "Shake all ingredients (except cola) with ice and strain into a chilled collins glass. Fill with cola and serve.",
        "ingredients": [
            "Gin",
            "Sweet and sour",
            "Egg",
            "Coke"
        ],
        "amounts": [
            "1 oz",
            "2 oz",
            "1 whole"
        ]
    },
    {
        "id": 69,
        "name": "Almeria",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rwsyyu1483388181.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a cocktail glass.",
        "ingredients": [
            "Rum - Dark",
            "Kahlua",
            "Egg white"
        ],
        "amounts": [
            "2 oz",
            "1 oz"
        ]
    },
    {
        "id": 415,
        "name": "Porto flip",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/64x5j41504351518.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake ingredients together in a mixer with ice. Strain into glass, garnish and serve.",
        "ingredients": [
            "Brandy",
            "Port",
            "Egg Yolk"
        ],
        "amounts": [
            "3 parts",
            "9 parts",
            "2 parts"
        ]
    },
    {
        "id": 145,
        "name": "Bleeding Surgeon",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/usuvvr1472719118.jpg",
        "glass": "Collins glass",
        "instructions": "Pour Shot of Rum over slice of orange. Fill the remaining space in glass half way full of surge or similar drink. Finish off glass with cranberry juice. Be carefull, warm surge may foam over the glass.",
        "ingredients": [
            "Rum - Dark",
            "Orange",
            "Energy Drink",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1 shot",
            "1 slice",
            "1/2 glass",
            "1/2 glass"
        ]
    },
    {
        "id": 59,
        "name": "Afternoon",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/vyrurp1472667777.jpg",
        "glass": "Collins Glass",
        "instructions": "Build into a suiting glass, with no ice. Cream on top if wanted. Served directly.",
        "ingredients": [
            "Kahlua",
            "Bailey's irish cream",
            "Frangelico",
            "Coffee",
            "Cream"
        ],
        "amounts": [
            "1 parts",
            "1 parts",
            "1 1/2",
            "4 parts hot"
        ]
    },
    {
        "id": 13,
        "name": 747,
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/xxsxqy1472668106.jpg",
        "glass": "Shot glass",
        "instructions": "pour kaluha, then Baileys, then Frangelico not chilled and not layered -- SERVE!!!",
        "ingredients": [
            "Kahlua",
            "Bailey's irish cream",
            "Frangelico"
        ],
        "amounts": [
            "1/3 part",
            "1/3 part",
            "1/3 part"
        ]
    },
    {
        "id": 440,
        "name": "Rum Punch",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wyrsxu1441554538.jpg",
        "glass": "Punch bowl",
        "instructions": "Mix all ingredients in a punch bowl and serve.",
        "ingredients": [
            "Rum",
            "Ginger ale",
            "Fruit punch",
            "Juice - Orange",
            "Ice"
        ],
        "amounts": [
            "mikey bottle",
            "large bottle",
            "355 ml frozen",
            "355 ml frozen",
            "crushed"
        ]
    },
    {
        "id": 259,
        "name": "Gagliardo",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/lyloe91487602877.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake well and serve in a cocktail glass. This is a home cocktail of American/Internet Bar del Pozzo, Pavia, Italy.",
        "ingredients": [
            "Vodka - Peach",
            "Juice - Lemon",
            "Galliano",
            "Sirup of roses"
        ],
        "amounts": [
            "5 parts",
            "3 parts",
            "1 part",
            "1 part"
        ]
    },
    {
        "id": 60,
        "name": "Alabama Slammer",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qtwxwr1483387647.jpg",
        "glass": "Highball glass",
        "instructions": "Pour all ingredients (except for lemon juice) over ice in a highball glass. Stir, add a dash of lemon juice, and serve.",
        "ingredients": [
            "Southern Comfort",
            "Amaretto",
            "Gin",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1/2 oz",
            "1 dash"
        ]
    },
    {
        "id": 335,
        "name": "Kool-Aid Shot",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/fegm621503564966.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour into a large glass with ice and stir. Add a little cranberry juice to taste.",
        "ingredients": [
            "Vodka",
            "Amaretto",
            "Gin",
            "Triple Sec",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "1 shot",
            "1 shot"
        ]
    },
    {
        "id": 87,
        "name": "Angel Face",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vqpptp1478253178.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice and strain contents into a cocktail glass.",
        "ingredients": [
            "Brandy",
            "Brandy - Apple",
            "Gin"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1 oz"
        ]
    },
    {
        "id": 486,
        "name": "Surf City Lifesaver",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/2rzfer1487602699.jpg",
        "glass": "Highball glass",
        "instructions": "Lots of ice and soda top up in tall glass with cherry and a grin.",
        "ingredients": [
            "Ouzo",
            "Bailey's irish cream",
            "Gin",
            "Triple Sec"
        ],
        "amounts": [
            "1 part",
            "1 part",
            "2 parts",
            "1/2 part"
        ]
    },
    {
        "id": 467,
        "name": "Singapore Sling",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tvtrrt1439906288.jpg",
        "glass": "Hurricane glass",
        "instructions": "Pour all ingredients into cocktail shaker filled with ice cubes. Shake well. Strain into highball glass. Garnish with pineapple and cocktail cherry.",
        "ingredients": [
            "Brandy - Cherry",
            "Grenadine",
            "Gin",
            "Sweet and sour",
            "Water - Soda",
            "Cherry"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1 oz",
            "2 oz"
        ]
    },
    {
        "id": 354,
        "name": "Long Island Tea",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ywxwqs1439906072.jpg",
        "glass": "Highball glass",
        "instructions": "Combine all ingredients (except cola) and pour over ice in a highball glass. Add the splash of cola for color. Decorate with a slice of lemon and serve.",
        "ingredients": [
            "Vodka",
            "Rum - Light",
            "Gin",
            "Tequila",
            "Lemon",
            "Coke"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "Juice of 1/2",
            "1 splash"
        ]
    },
    {
        "id": 271,
        "name": "Gin Swizzle",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/sybce31504884026.jpg",
        "glass": "Highball glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the lime juice, sugar, gin, and bitters. Shake well. Almost fill a colling glass with ice cubes. Stir until the glass is frosted. Strain the mixture in the shaker into the glass and add the partsub soda.",
        "ingredients": [
            "Juice - Lime",
            "Sugar",
            "Gin",
            "Bitters",
            "partsub soda"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 tsp superfine",
            "2 oz",
            "1 dash",
            "3 oz"
        ]
    },
    {
        "id": 385,
        "name": "National Aquarium",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/dlw0om1503565021.jpg",
        "glass": "Collins Glass",
        "instructions": "Pour all ingredients into a shaker of ice. Shake well. Serve on the rocks.",
        "ingredients": [
            "Rum",
            "Vodka",
            "Gin",
            "Triple Sec",
            "Sour mix",
            "Sprite"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "2 oz",
            "1 splash"
        ]
    },
    {
        "id": 296,
        "name": "Horse's Neck",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/006k4e1504370092.jpg",
        "glass": "Highball glass",
        "instructions": "Pour brandy and ginger ale directly into highball glass with ice cubes. Stir gently. Garnish with lemon zest. If desired, add dashes of Angostura Bitter.",
        "ingredients": [
            "Peel - Lemon",
            "Brandy",
            "Ginger ale",
            "Bitters"
        ],
        "amounts": [
            "1 long strip",
            "2 oz",
            "5 oz",
            "2 dashes"
        ]
    },
    {
        "id": 38,
        "name": "Absolutely Cranberry Smash",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vqwstv1472811884.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir ingredients together. Serve over ice.",
        "ingredients": [
            "Vodka",
            "Juice - Cranberry",
            "Ginger ale",
            "Ice"
        ],
        "amounts": [
            "2 oz",
            "4 oz",
            "2 oz",
            "Add"
        ]
    },
    {
        "id": 381,
        "name": "Moscow Mule",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3pylqc1504370988.jpg",
        "glass": "Copper Mug",
        "instructions": "Combine vodka and ginger beer in a highball glass filled with ice. Add lime juice. Stir gently. Garnish.",
        "ingredients": [
            "Vodka",
            "Juice - Lime",
            "Ginger ale"
        ],
        "amounts": [
            "2 oz",
            "2 oz",
            "8 oz"
        ]
    },
    {
        "id": 156,
        "name": "Boozy Snickers Milkshake",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/861tzm1504784164.jpg",
        "glass": "Mason jar",
        "instructions": "Place the snickers bars in a plastic bag and roll over them with a rolling pin until crushed. Add crushed snickers pieces, ice cream, milk, caramel sauce, chocolate sauce, and chocolate liquor to a blender. Blend until shake is thick and frothy. Pour into glasses and top with chocolate liquor and whip cream.",
        "ingredients": [
            "Vanilla Ice-Cream",
            "Milk",
            "Godiva liqueur",
            "Whipped Cream",
            "caramel sauce",
            "chocolate sauce",
            "Mini-snickers bars"
        ],
        "amounts": [
            "3 cups",
            "1 cup",
            "1/2 cup",
            "for topping",
            "4 tablespoons",
            "4 tablespoons"
        ]
    },
    {
        "id": 106,
        "name": "Arizona Twister",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/ido1j01493068134.jpg",
        "glass": "Hurricane glass",
        "instructions": "Just mix in the shots of rum, vodka, and tequila. Add splashes of the three juices, heavy on the pineapple. Top off with grenadine. Crushed ice should already be in glass. Top off the glass with a pineapple wedge.",
        "ingredients": [
            "Vodka",
            "Rum - Coconunt",
            "Gold tequila",
            "Juice - Orange",
            "Juice - Pineapple",
            "Cream of coconut",
            "Grenadine",
            "Ice",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "1 shot",
            "1 splash",
            "1 splash",
            "1 splash",
            "1 dash",
            "crushed",
            "1 wedge"
        ]
    },
    {
        "id": 371,
        "name": "Midnight Manx",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/uqqurp1441208231.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Fill a mixer with ice and add Baileys, Kahlua, Goldshlager, and cream. Shake for 5 seconds and Strain into a double rocks glass filled with ice. Add chilled coffee Stir and enjoy!",
        "ingredients": [
            "Kahlua",
            "Bailey's irish cream",
            "Goldschlager",
            "Cream",
            "Coffee"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "dash",
            "2 oz",
            "2 oz Hazlenut"
        ]
    },
    {
        "id": 153,
        "name": "Bob Marley",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/rrqrst1477140664.jpg",
        "glass": "Shot glass",
        "instructions": "Layer in a 2 oz shot glass or pony glass",
        "ingredients": [
            "Liqueur - Melon",
            "Jägermeister",
            "Goldschlager"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 211,
        "name": "Creme de Menthe",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/yxswtp1441253918.jpg",
        "glass": "Collins Glass",
        "instructions": "Bring sugar and water to a boil and simmer for 10 minutes. Cool. Add the remaining ingredients and stir. Cover and let ripen for 1 month.",
        "ingredients": [
            "Sugar",
            "Water",
            "Grain alcohol",
            "Peppermint extract",
            "Food coloring"
        ],
        "amounts": [
            "8 cups",
            "6 cups",
            "1 pint",
            "1 oz pure",
            "1 tblsp green"
        ]
    },
    {
        "id": 458,
        "name": "Sea breeze",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/7rfuks1504371562.jpg",
        "glass": "Highball glass",
        "instructions": "Build all ingredients in a highball glass filled with ice. Garnish with lime wedge.",
        "ingredients": [
            "Vodka",
            "Juice - Cranberry",
            "Grapefruit juice"
        ],
        "amounts": [
            "1 1/2 oz",
            "4 oz",
            "1 oz"
        ]
    },
    {
        "id": 284,
        "name": "Grim Reaper",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/kztu161504883192.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Mix Kahlua and 151 in glass. Quickly add ice and pour grenadine over ice to give ice red tint.",
        "ingredients": [
            "Kahlua",
            "Rum - Strong",
            "Grenadine"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 dash"
        ]
    },
    {
        "id": 460,
        "name": "Shanghai Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ttyrxr1478820678.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Rum - Light",
            "Anisette",
            "Grenadine",
            "Lemon"
        ],
        "amounts": [
            "1 oz Jamaican",
            "1 tsp",
            "1/2 tsp",
            "Juice of 1/4"
        ]
    },
    {
        "id": 435,
        "name": "Ruby Tuesday",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/qsyqqq1441553437.jpg",
        "glass": "Highball glass",
        "instructions": "Pour gin and cranberry into a highball filled with ice cubes. Add grenadine and stir.",
        "ingredients": [
            "Gin",
            "Juice - Cranberry",
            "Grenadine"
        ],
        "amounts": [
            "2 oz",
            "5 oz",
            "2 splashes"
        ]
    },
    {
        "id": 448,
        "name": "San Francisco",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/szmj2d1504889961.jpg",
        "glass": "Highball glass",
        "instructions": "Take a tall glass and put in a few ice cubes, fill the vodka over it and fill with juice then the \"creme\", to end fill in the grenadine but very carefully at the side of the glass so it will lay down in the bottom. garnish with orange and strawberry.",
        "ingredients": [
            "Vodka",
            "Creme de Banane",
            "Grenadine",
            "Juice - Orange"
        ],
        "amounts": [
            "2 parts",
            "2 parts"
        ]
    },
    {
        "id": 43,
        "name": "Adam",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rwuxsv1472812169.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a cocktail glass.",
        "ingredients": [
            "Rum - Dark",
            "Juice - Lemon",
            "Grenadine"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1 tsp"
        ]
    },
    {
        "id": 493,
        "name": "Tequila Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/2bcase1504889637.jpg",
        "glass": "Collins glass",
        "instructions": "Shake all ingredients (except ginger ale) with ice and strain into a collins glass over ice cubes. Fill with ginger ale, stir, and serve.",
        "ingredients": [
            "Tequila",
            "Juice - Lemon",
            "Grenadine",
            "Egg white",
            "Ginger ale"
        ],
        "amounts": [
            "2 oz",
            "1 tblsp",
            "3/4 oz"
        ]
    },
    {
        "id": 82,
        "name": "Amaretto Sunrise",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/akcpsh1493070267.jpg",
        "glass": "Collins Glass",
        "instructions": "Mix together the amaretto and orange juice. Pour into glass and then add the grenadine untill you see the sunrise.",
        "ingredients": [
            "Amaretto",
            "Juice - Orange",
            "Grenadine"
        ],
        "amounts": [
            "1 parts",
            "4 oz",
            "1/4 parts"
        ]
    },
    {
        "id": 495,
        "name": "Tequila Sunrise",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/quqyqp1480879103.jpg",
        "glass": "Highball glass",
        "instructions": "Pour the tequila and orange juice into glass over ice. Add the grenadine, which will sink to the bottom. Stir gently to create the sunrise effect. Garnish and serve.",
        "ingredients": [
            "Tequila",
            "Juice - Orange",
            "Grenadine"
        ],
        "amounts": [
            "2 measures"
        ]
    },
    {
        "id": 320,
        "name": "Jitterbug",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/wwqvrq1441245318.jpg",
        "glass": "Cocktail Glass",
        "instructions": "Wet glass, dip rim in sugar. Then add Ice. Then add everything else. It's that simple!",
        "ingredients": [
            "Gin",
            "Vodka",
            "Grenadine",
            "Juice - Lime",
            "Sugar",
            "Simple Syrup",
            "Water - Soda"
        ],
        "amounts": [
            "2 jiggers",
            "1 jigger",
            "3 dashes",
            "1 shot",
            "Around rim put 1 pinch",
            "3 dashes",
            "Fill to top with"
        ]
    },
    {
        "id": 332,
        "name": "Kiwi Lemon",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tpupvr1478251697.jpg",
        "glass": "Highball glass",
        "instructions": "Mix in highball glass. Stirr. Garnish with slice of kiwi.",
        "ingredients": [
            "Liqueur - Kiwi",
            "Bitters",
            "Ice"
        ],
        "amounts": [
            "1 part",
            "2 parts",
            "cubes"
        ]
    },
    {
        "id": 21,
        "name": "A True Amaretto Sour",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/rptuxy1472669372.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Rub the rim of an old fashioned glass with lemon, and dip repeatedly into granulated sugar until it has a good \"frosted\" rim. Shake a jigger of Amaretto with the juice of 1/2 a lemon. Strain into glass and add ice. Garnish with a Marachino Cherry.",
        "ingredients": [
            "Amaretto",
            "Lemon",
            "Ice",
            "Cherry"
        ],
        "amounts": [
            "1 jigger",
            "Juice of 1/2"
        ]
    },
    {
        "id": 542,
        "name": "Zizi Coin-coin",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/0fbo2t1485620752.jpg",
        "glass": "Margarita/Coupette glass",
        "instructions": "Pour 5parts of Cointreau on ice, add 2parts of fresh lemon (or lime) juice, stir gently, and finally add slices of lemon/lime in glass.",
        "ingredients": [
            "Triple Sec",
            "Juice - Lemon",
            "Ice",
            "Lemon"
        ],
        "amounts": [
            "5 parts",
            "2 parts",
            "cubes",
            "or lime"
        ]
    },
    {
        "id": 428,
        "name": "Raspberry Cooler",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/suqyyx1441254346.jpg",
        "glass": "Highball glass",
        "instructions": "Pour the raspberry vodka and soda into a highball glass almost filled with ice cubes. Stir well.",
        "ingredients": [
            "Vodka - Raspberry",
            "Sprite",
            "Ice"
        ],
        "amounts": [
            "2 oz",
            "4 oz"
        ]
    },
    {
        "id": 314,
        "name": "Jamaica Kiss",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/urpvvv1441249549.jpg",
        "glass": "Hurricane glass",
        "instructions": "Fill a tumbler with ice cubes. Add a shot of Tia Maria and a shot of Jamaican light rum. Fill the tumbler with milk. Blend until smooth and serve immediately.",
        "ingredients": [
            "Liqueur - Coffee",
            "Rum - Light",
            "Ice",
            "Milk"
        ],
        "amounts": [
            "1 shot",
            "1 shot Jamaican",
            "cubes"
        ]
    },
    {
        "id": 37,
        "name": "Absolut limousine",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/ssqpyw1472719844.jpg",
        "glass": "Collins Glass",
        "instructions": "Fill Absolut into a glass. Add Lime juice. Add Ice and lime wedges.",
        "ingredients": [
            "Vodka - Citrus",
            "Juice - Lime",
            "Ice",
            "Water - Tonic"
        ],
        "amounts": [
            "2/3",
            "1/3",
            "Fill with",
            "Top it up with"
        ]
    },
    {
        "id": 33,
        "name": "Absolut Evergreen",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/wrxrxp1472812609.jpg",
        "glass": "Collins Glass",
        "instructions": "Mix, pour over ice and top up with Bitter Lemon.",
        "ingredients": [
            "Vodka - Citrus",
            "Pisang Ambon",
            "Ice",
            "Bitter lemon"
        ],
        "amounts": [
            "2/3 part",
            "1/3 part",
            "cubes"
        ]
    },
    {
        "id": 534,
        "name": "Zambeer",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/bje5401485619578.jpg",
        "glass": "Collins Glass",
        "instructions": "Mix sambuca with rootbeer and stir. Add ice",
        "ingredients": [
            "Sambuca",
            "Root beer",
            "Ice"
        ],
        "amounts": [
            "1 1/2 oz",
            "Add 10 oz",
            "cubes"
        ]
    },
    {
        "id": 19,
        "name": "A Piece of Ass",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/tqxyxx1472719737.jpg",
        "glass": "Highball glass",
        "instructions": "Put ice in glass. Pour in shots. Fill with Sour Mix.",
        "ingredients": [
            "Amaretto",
            "Southern Comfort",
            "Ice",
            "Sour mix"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "cubes"
        ]
    },
    {
        "id": 7,
        "name": "3 Wise Men",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/wxqpyw1468877677.jpg",
        "glass": "Collins glass",
        "instructions": "put them them in a glass... and slam it to tha head.",
        "ingredients": [
            "Bourbon",
            "Johnnie Walker",
            "Jim Beam"
        ],
        "amounts": [
            "1/3 oz",
            "1/3 oz",
            "1/3 oz"
        ]
    },
    {
        "id": 116,
        "name": "Avalon",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3k9qic1493068931.jpg",
        "glass": "Highball glass",
        "instructions": "Fill a tall glass with ice. Layer the Finlandia Vodka, lemon and apple juices, Pisang Ambon, and top up with lemonade. Stir slightly and garnish with a spiralled cucumber skin and a red cherry. The cucumber provides zest and looks attractive. This drink, created by Timo Haimi, took first prize in the 1991 Finlandia Vodka Long Drink Competition.",
        "ingredients": [
            "Vodka",
            "Pisang Ambon",
            "Juice - Apple",
            "Juice - Lemon",
            "Lemonade"
        ],
        "amounts": [
            "3 parts",
            "1 part",
            "6 parts",
            "1 1/2 part"
        ]
    },
    {
        "id": 429,
        "name": "Red Snapper",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/7p607y1504735343.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "One shot each, shake n shoot",
        "ingredients": [
            "Whiskey",
            "Amaretto",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "1 shot"
        ]
    },
    {
        "id": 410,
        "name": "Popped cherry",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/sxvrwv1473344825.jpg",
        "glass": "Highball glass",
        "instructions": "Served over ice in a tall glass with a popped cherry (can add more popped cherries if in the mood)!",
        "ingredients": [
            "Vodka",
            "Cherry liqueur",
            "Juice - Cranberry",
            "Juice - Orange"
        ],
        "amounts": [
            "2 oz",
            "2 oz",
            "4 oz",
            "4 oz"
        ]
    },
    {
        "id": 34,
        "name": "Absolut Sex",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/xtrvtx1472668436.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Shake Absolut Kurant, Midori, and Cranberry juice in shaker with ice: Strain into rocks glass: Splash of seven on top.Absolut Sex.",
        "ingredients": [
            "Vodka - Berry",
            "Liqueur - Melon",
            "Juice - Cranberry",
            "Sprite"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "1 oz",
            "1 splash"
        ]
    },
    {
        "id": 52,
        "name": "Affair",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wxrsxx1472720734.jpg",
        "glass": "Highball glass",
        "instructions": "Pour schnapps, orange juice, and cranberry juice over ice in a highball glass. Top with partsub soda and serve.",
        "ingredients": [
            "Liqueur - Strawberry",
            "Juice - Orange",
            "Juice - Cranberry",
            "partsub soda"
        ],
        "amounts": [
            "2 oz",
            "2 oz",
            "2 oz"
        ]
    },
    {
        "id": 459,
        "name": "Sex on the Beach",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/twsvwr1469092365.jpg",
        "glass": "Highball glass",
        "instructions": "Build all ingredients in a highball glass filled with ice. Garnish with orange slice.",
        "ingredients": [
            "Vodka",
            "Peach schnapps",
            "Juice - Cranberry",
            "Grapefruit juice"
        ],
        "amounts": [
            "1 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 359,
        "name": "Malibu Twister",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/2dwae41504885321.jpg",
        "glass": "Highball glass",
        "instructions": "Add rum & trister then, add cranberry jucie,stir",
        "ingredients": [
            "Rum - Cocounut",
            "Juice - Orange",
            "Juice - Cranberry"
        ],
        "amounts": [
            "2 parts",
            "2 parts",
            "1 part"
        ]
    },
    {
        "id": 519,
        "name": "Victory Collins",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/lx0lvs1492976619.jpg",
        "glass": "Collins glass",
        "instructions": "Shake all ingredients (except orange slice) with ice and strain into a collins glass over ice cubes. Add the slice of orange and serve.",
        "ingredients": [
            "Vodka",
            "Juice - Lemon",
            "Juice - Grape",
            "Sugar",
            "Orange"
        ],
        "amounts": [
            "1 1/2 oz",
            "3 oz",
            "3 oz unsweetened",
            "1 tsp",
            "1 slice"
        ]
    },
    {
        "id": 12,
        "name": "69 Special",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vqyxqx1472669095.jpg",
        "glass": "Collins Glass",
        "instructions": "Pour 2 oz. gin. Add 4 oz. 7-up. Add Lemon Juice for flavor. If you are weak, top up glass with more 7-Up.",
        "ingredients": [
            "Gin",
            "Sprite",
            "Juice - Lemon"
        ],
        "amounts": [
            "2 oz dry",
            "4 oz",
            "0.75 oz"
        ]
    },
    {
        "id": 56,
        "name": "After Supper Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/quyxwu1483387610.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Triple Sec",
            "Brandy - Apricot",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1/2 tsp"
        ]
    },
    {
        "id": 465,
        "name": "Sidecar",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/stwxuq1439906852.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into cocktail shaker filled with ice. Shake well and strain into cocktail glass.",
        "ingredients": [
            "Cognac",
            "Triple Sec",
            "Juice - Lemon"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "1 oz"
        ]
    },
    {
        "id": 25,
        "name": "A1",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/2x8thr1504816928.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into a cocktail shaker, mix and serve over ice into a chilled glass.",
        "ingredients": [
            "Gin",
            "Triple Sec",
            "Juice - Lemon",
            "Grenadine"
        ],
        "amounts": [
            "1 3/4 shot",
            "1 Shot",
            "1/4 Shot",
            "1/8 Shot"
        ]
    },
    {
        "id": 108,
        "name": "Arthur Tompkins",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/7onfhz1493067921.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the gin, Grand Marnier, and lemon juice. Shake well. Strain into a sour glass and garnish with the lemon twist.",
        "ingredients": [
            "Gin",
            "Triple Sec",
            "Juice - Lemon",
            "Peel - Lemon"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "2 tsp",
            "1 twist"
        ]
    },
    {
        "id": 387,
        "name": "New York Lemonade",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/b3n0ge1503565473.jpg",
        "glass": "Cocktail glass",
        "instructions": "Serve in a chilled cocktail glass. Lemon and sugar the rim. Stir and Strain.",
        "ingredients": [
            "Vodka - Citrus",
            "Triple Sec",
            "Juice - Lemon",
            "partsub soda"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "2 oz sweetened",
            "1 oz"
        ]
    },
    {
        "id": 299,
        "name": "Ice Pick #1",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ypsrqp1469091726.jpg",
        "glass": "Collins Glass",
        "instructions": "Put Vodka in glass fill with iced tea. Stir in lemon to taste.",
        "ingredients": [
            "Vodka",
            "Iced tea",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 1/2 oz",
            "6 oz",
            "to taste"
        ]
    },
    {
        "id": 513,
        "name": "Van Vleet",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/fgq2bl1492975771.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Shake all ingredients with ice, strain into an old-fashioned glass over ice cubes, and serve.",
        "ingredients": [
            "Rum - Light",
            "Maple syrup",
            "Juice - Lemon"
        ],
        "amounts": [
            "3 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 186,
        "name": "Casino",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/1mvjxg1504348579.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into shaker with ice cubes. Shake well. Strain into chilled cocktail glass. Garnish with a lemon twist and a maraschino cherry. Serve without a straw.",
        "ingredients": [
            "Gin",
            "Liqueur - Cherry",
            "Juice - Lemon",
            "Bitters",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "1/4 tsp",
            "1/4 tsp",
            "2 dashes"
        ]
    },
    {
        "id": 289,
        "name": "Havana Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/59splc1504882899.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a cocktail glass.",
        "ingredients": [
            "Rum - Light",
            "Juice - Pineapple",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 tsp"
        ]
    },
    {
        "id": 246,
        "name": "French \"75",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qpvxsx1439906903.jpg",
        "glass": "Collins glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the gin, sugar, and lemon juice. Shake well. Pour into a collins glass. Top with the Champagne. Stir well and garnish with the orange slice and the cherry.",
        "ingredients": [
            "Gin",
            "Sugar",
            "Juice - Lemon",
            "Champagne",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "1 1/2 oz",
            "2 tsp superfine",
            "1 1/2 oz",
            "4 oz Chilled"
        ]
    },
    {
        "id": 247,
        "name": "French 75",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/4qnyty1504368615.jpg",
        "glass": "Collins glass",
        "instructions": "Combine gin, sugar, and lemon juice in a cocktail shaker filled with ice. Shake vigorously and strain into a chilled champagne glass. Top up with Champagne. Stir gently.",
        "ingredients": [
            "Gin",
            "Sugar",
            "Juice - Lemon",
            "Champagne",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "1 1/2 oz",
            "2 tsp superfine",
            "1 1/2 oz",
            "4 oz Chilled"
        ]
    },
    {
        "id": 147,
        "name": "Bloody Maria",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yz0j6z1504389461.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Shake all ingredients (except lemon slice) with cracked ice and strain into an old-fashioned glass over ice cubes. Add the slice of lemon and serve.",
        "ingredients": [
            "Tequila",
            "Tomato juice",
            "Juice - Lemon",
            "Tabasco",
            "Celery salt",
            "Lemon"
        ],
        "amounts": [
            "1 oz",
            "2 oz",
            "1 dash",
            "1 dash",
            "1 dash",
            "1 slice"
        ]
    },
    {
        "id": 148,
        "name": "Bloody Mary",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/uyquuu1439906954.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Stirring gently, pour all ingredients into highball glass. Garnish.",
        "ingredients": [
            "Vodka",
            "Tomato juice",
            "Juice - Lemon",
            "Worcestershire sauce",
            "Tabasco",
            "Lime"
        ],
        "amounts": [
            "1 1/2 oz",
            "3 oz",
            "1 dash",
            "1/2 tsp",
            "2-3 drops",
            "1 wedge"
        ]
    },
    {
        "id": 199,
        "name": "City Slicker",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/dazdlg1504366949.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a cocktail glass.",
        "ingredients": [
            "Brandy",
            "Triple Sec",
            "Juice - Lemon"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "1 tblsp"
        ]
    },
    {
        "id": 162,
        "name": "Boxcar",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/pwgtpa1504366376.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a sour glass.",
        "ingredients": [
            "Gin",
            "Triple Sec",
            "Juice - Lemon",
            "Grenadine",
            "Egg white"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1 tsp",
            "1/2 tsp"
        ]
    },
    {
        "id": 527,
        "name": "White Lady",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/jofsaz1504352991.jpg",
        "glass": "Cocktail glass",
        "instructions": "Add all ingredients into cocktail shaker filled with ice. Shake well and strain into large cocktail glass.",
        "ingredients": [
            "Gin",
            "Triple Sec",
            "Juice - Lemon"
        ],
        "amounts": [
            "4parts",
            "3parts",
            "2parts"
        ]
    },
    {
        "id": 160,
        "name": "Bourbon Sling",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3s36ql1504366260.jpg",
        "glass": "Highball glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the sugar, water, lemon juice, and bourbon. Shake well. Strain well. Strain into a highball glass. Garnish with the lemon twist.",
        "ingredients": [
            "Sugar",
            "Water",
            "Juice - Lemon",
            "Bourbon",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 tsp superfine",
            "2 tsp",
            "1 oz",
            "2 oz",
            "1 twist"
        ]
    },
    {
        "id": 150,
        "name": "Blue Margarita",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qtvvyq1439905913.jpg",
        "glass": "Cocktail glass",
        "instructions": "Rub rim of cocktail glass with lime juice. Dip rim in coarse salt. Shake tequila, blue curacao, and lime juice with ice, strain into the salt-rimmed glass, and serve.",
        "ingredients": [
            "Tequila",
            "Triple Sec",
            "Juice - Lime",
            "Salt"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1 oz",
            "Coarse"
        ]
    },
    {
        "id": 529,
        "name": "Whitecap Margarita",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/srpxxp1441209622.jpg",
        "glass": "Margarita/Coupette glass",
        "instructions": "Place all ingredients in a blender and blend until smooth. This makes one drink.",
        "ingredients": [
            "Tequila",
            "Cream of coconut",
            "Juice - Lime"
        ],
        "amounts": [
            "2 oz",
            "1/4 cup",
            "3 tblsp fresh"
        ]
    },
    {
        "id": 521,
        "name": "Vodka Fizz",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/xwxyux1441254243.jpg",
        "glass": "White wine glass",
        "instructions": "Blend all ingredients, save nutmeg. Pour into large white wine glass and sprinkle nutmeg on top.",
        "ingredients": [
            "Vodka",
            "Half-and-half",
            "Juice - Lime",
            "Ice",
            "Nutmeg"
        ],
        "amounts": [
            "2 oz",
            "2 oz",
            "2 oz"
        ]
    },
    {
        "id": 481,
        "name": "Strawberry Daiquiri",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/deu59m1504736135.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into shaker with ice cubes. Shake well. Strain in chilled cocktail glass.",
        "ingredients": [
            "Liqueur - Strawberry",
            "Rum - Light",
            "Juice - Lime",
            "Sugar",
            "Strawberries"
        ],
        "amounts": [
            "1/2 oz",
            "1 oz",
            "1 oz",
            "1 tsp",
            "1 oz"
        ]
    },
    {
        "id": 253,
        "name": "Frozen Pineapple Daiquiri",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/j2mqsb1504736097.jpg",
        "glass": "Champagne flute",
        "instructions": "Combine all ingredients with 1 cup of crushed ice in an electric blender. Blend at a low speed for a short length of time. Pour into a champagne flute and serve.",
        "ingredients": [
            "Rum - Light",
            "Juice - Pineapple",
            "Juice - Lime",
            "Sugar"
        ],
        "amounts": [
            "1 1/2 oz",
            "4 chunks",
            "1 tblsp",
            "1/2 tsp"
        ]
    },
    {
        "id": 41,
        "name": "Acapulco",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vtpsvr1472811976.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Combine and shake all ingredients (except mint) with ice and strain into an old-fashioned glass over ice cubes. Add the sprig of mint and serve.",
        "ingredients": [
            "Rum - Light",
            "Triple Sec",
            "Juice - Lime",
            "Sugar",
            "Egg white",
            "Mint"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 1/2 tsp",
            "1 tblsp",
            "1 tsp"
        ]
    },
    {
        "id": 251,
        "name": "Frozen Daiquiri",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/7oyrj91504884412.jpg",
        "glass": "Champagne flute",
        "instructions": "Combine all ingredients (except for the cherry) in an electric blender and blend at a low speed for five seconds, then blend at a high speed until firm. Pour contents into a champagne flute, top with the cherry, and serve.",
        "ingredients": [
            "Rum - Light",
            "Triple Sec",
            "Juice - Lime",
            "Sugar",
            "Cherry",
            "Ice"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 tblsp",
            "1 1/2 oz",
            "1 tsp",
            "1 cup crushed"
        ]
    },
    {
        "id": 362,
        "name": "Margarita",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wpxpvu1439905379.jpg",
        "glass": "Cocktail glass",
        "instructions": "Rub the rim of the glass with the lime slice to make the salt stick to it. Take care to moisten only the outer rim and sprinkle the salt on it. The salt should present to the lips of the imbiber and never mix into the cocktail. Shake the other ingredients with ice, then carefully pour into the glass.",
        "ingredients": [
            "Tequila",
            "Triple Sec",
            "Juice - Lime",
            "Salt"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1 oz"
        ]
    },
    {
        "id": 323,
        "name": "Kamikaze",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xa58bb1504373204.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients together with ice. Strain into glass, garnish and serve.",
        "ingredients": [
            "Vodka",
            "Triple Sec",
            "Juice - Lime"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 107,
        "name": "Army special",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/55muhh1493068062.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour Vodka, Gin and lime cordial into glass, and top up with crushed ice. Wait for ice to melt slightly and sip without a straw.",
        "ingredients": [
            "Vodka",
            "Gin",
            "Juice - Lime cordial",
            "Ice"
        ],
        "amounts": [
            "30 ml",
            "30 ml",
            "45 ml",
            "1/2 glass crushed"
        ]
    },
    {
        "id": 15,
        "name": "A Day at the Beach",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/trptts1454514474.jpg",
        "glass": "Highball glass",
        "instructions": "Shake Rum, Amaretto, and Orange Juice in a shaker filled with ice. Strain over ice into a highball glass. Add Grenadine and garnish with a Pineapple Wedge and a Strawberry.",
        "ingredients": [
            "Rum - Coconut",
            "Amaretto",
            "Juice - Orange",
            "Grenadine"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "4 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 18,
        "name": "A Night In Old Mandalay",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vyrvxt1461919380.jpg",
        "glass": "Highball glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the light rum, añejo rum, orange juice, and lemon juice. Shake well. Strain into a highball glass almost filled with ice cubes. Top with the ginger ale. Garnish with the lemon twist.",
        "ingredients": [
            "Rum - Light",
            "Rum - Dark",
            "Juice - Orange",
            "Juice - Lemon",
            "Ginger ale",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz",
            "1/2 oz",
            "3 oz",
            "1 twist"
        ]
    },
    {
        "id": 401,
        "name": "Paradise",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ejozd71504351060.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake together over ice. Strain into cocktail glass and serve chilled.",
        "ingredients": [
            "Gin",
            "Brandy - Apricot",
            "Juice - Orange"
        ],
        "amounts": [
            "7 parts",
            "4 parts",
            "3 parts"
        ]
    },
    {
        "id": 174,
        "name": "Bubble Gum",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/spuurv1468878783.jpg",
        "glass": "Shot glass",
        "instructions": "Layer in order into a shot glass.",
        "ingredients": [
            "Vodka",
            "Liqueur - Banana",
            "Juice - Orange",
            "Liqueur - Peach"
        ],
        "amounts": [
            "1/4",
            "1/4",
            "1/4",
            "1/4"
        ]
    },
    {
        "id": 378,
        "name": "Monkey Gland",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/94psp81504350690.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake well over ice cubes in a shaker, strain into a chilled cocktail glass.",
        "ingredients": [
            "Gin",
            "Benedictine",
            "Juice - Orange",
            "Grenadine"
        ],
        "amounts": [
            "2 oz",
            "1 tsp",
            "1/2 oz",
            "1 tsp"
        ]
    },
    {
        "id": 441,
        "name": "Rum Runner",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vqws6t1504888857.jpg",
        "glass": "Cocktail glass",
        "instructions": "Mix all ingredients in glass & add ice.",
        "ingredients": [
            "Rum - Cocounut",
            "Brandy - Blackberry",
            "Juice - Orange",
            "Juice - Pineapple",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "3-4 oz",
            "3-4 oz",
            "3-4 oz"
        ]
    },
    {
        "id": 57,
        "name": "After sex",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xrl66i1493068702.jpg",
        "glass": "Highball glass",
        "instructions": "Pour the vodka and creme over some ice cubes in a tall glass and fill up with juice. to make it beuty full make the top of the glass with a grenadine and sugar",
        "ingredients": [
            "Vodka",
            "Creme de Banane",
            "Juice - Orange"
        ],
        "amounts": [
            "2 parts",
            "1 parts"
        ]
    },
    {
        "id": 288,
        "name": "Harvey Wallbanger",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vg4bva1504369725.jpg",
        "glass": "Collins glass",
        "instructions": "Stir the vodka and orange juice with ice in the glass, then float the Galliano on top. Garnish and serve.",
        "ingredients": [
            "Vodka",
            "Galliano",
            "Juice - Orange"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "4 oz"
        ]
    },
    {
        "id": 393,
        "name": "Orange Oasis",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xqqytq1441167923.jpg",
        "glass": "Highball glass",
        "instructions": "Shake brandy, gin, and orange juice with ice and strain into a highball glass over ice cubes. Fill with ginger ale, stir, and serve.",
        "ingredients": [
            "Brandy - Cherry",
            "Gin",
            "Juice - Orange",
            "Ginger ale"
        ],
        "amounts": [
            "1/2 oz",
            "1 1/2 oz",
            "4 oz"
        ]
    },
    {
        "id": 10,
        "name": "50/50",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wwpyvr1461919316.jpg",
        "glass": "Collins Glass",
        "instructions": "fill glass with crushed ice. Add vodka. Add a splash of grand-marnier. Fill with o.j.",
        "ingredients": [
            "Vodka - Vanilla",
            "Triple Sec",
            "Juice - Orange"
        ],
        "amounts": [
            "2 1/2 oz",
            "1 splash",
            "Fill with"
        ]
    },
    {
        "id": 101,
        "name": "Arctic Fish",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ttsvwy1472668781.jpg",
        "glass": "Beer pilsner",
        "instructions": "Fill glass with ice and fish, add vodka, grape soda and orange juice. DO NOT STIR!!!!! Serve well chilled.",
        "ingredients": [
            "Vodka",
            "Grape soda",
            "Juice - Orange",
            "Ice",
            "Candy"
        ],
        "amounts": [
            "1/3 part",
            "1/3 part",
            "1/3 part",
            "lots",
            "1 dash"
        ]
    },
    {
        "id": 394,
        "name": "Orange Push-up",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/mgf0y91503565781.jpg",
        "glass": "Hurricane glass",
        "instructions": "Combine liquors in a blender. Add a half scoop of ice and blend. Garnish with an orange and cherry flag. So good it will melt in your mouth!!!",
        "ingredients": [
            "Rum - Spiced",
            "Grenadine",
            "Juice - Orange",
            "Sour mix"
        ],
        "amounts": [
            "1.5 oz",
            "0.5 oz",
            "4 oz",
            "1 splash"
        ]
    },
    {
        "id": 49,
        "name": "Addison Special",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/4vo5651493068493.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Combine ingredients in the order listed into a shaker. Fill half full with ice and shake well. Strain into glass with ice and garnish with a cherry and orange wedge.",
        "ingredients": [
            "Vodka",
            "Grenadine",
            "Juice - Orange"
        ],
        "amounts": [
            "1 shot",
            "1 tblsp",
            "Fill with"
        ]
    },
    {
        "id": 531,
        "name": "Wine Punch",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/txustu1473344310.jpg",
        "glass": "Collins Glass",
        "instructions": "Combine all of the ingredients and pour over a block of ice.",
        "ingredients": [
            "Wine - Red",
            "Lemon",
            "Juice - Orange",
            "Orange",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1 bottle",
            "1 cup",
            "1 cup"
        ]
    },
    {
        "id": 409,
        "name": "Planter's Punch",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yvos231504351384.jpg",
        "glass": "Collins glass",
        "instructions": "Pour all ingredients, except the bitters, into shaker filled with ice. Shake well. Pour into large glass, filled with ice. Add Angostura bitters, \"on top\". Garnish with cocktail cherry and pineapple.",
        "ingredients": [
            "Rum - Dark",
            "Orgeat syrup",
            "Juice - Orange",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1 part",
            "1/2 part",
            "2 parts",
            "1 part"
        ]
    },
    {
        "id": 309,
        "name": "Irish Spring",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/sot8v41504884783.jpg",
        "glass": "Collins glass",
        "instructions": "Pour all ingredients (except orange slice and cherry) into a collins glass over ice cubes. Garnish with the slice of orange, add the cherry on top, and serve.",
        "ingredients": [
            "Whiskey - Irish",
            "Peach brandy",
            "Juice - Orange",
            "Sweet and sour",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "1 oz",
            "1 oz",
            "1 slice"
        ]
    },
    {
        "id": 31,
        "name": "Abilene",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ysqwwt1461919465.jpg",
        "glass": "Highball glass",
        "instructions": "Pour all of the ingredients into a highball glass almost filled with ice cubes. Stir well.",
        "ingredients": [
            "Rum - Dark",
            "Peach nectar",
            "Juice - Orange"
        ],
        "amounts": [
            "1 1/2 oz",
            "2 oz",
            "3 oz"
        ]
    },
    {
        "id": 17,
        "name": "A Gilligan's Island",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/wysqut1461867176.jpg",
        "glass": "Collins glass",
        "instructions": "Shaken, not stirred!",
        "ingredients": [
            "Vodka",
            "Peach schnapps",
            "Juice - Orange",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "3 oz",
            "3 oz"
        ]
    },
    {
        "id": 80,
        "name": "Amaretto Stone Sour",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/xwryyx1472719921.jpg",
        "glass": "Collins Glass",
        "instructions": "Shake and Serve over ice",
        "ingredients": [
            "Amaretto",
            "Sour mix",
            "Juice - Orange"
        ],
        "amounts": [
            "1 part",
            "1 part",
            "1 part"
        ]
    },
    {
        "id": 449,
        "name": "Sangria #1",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xrvxpp1441249280.jpg",
        "glass": "Pitcher",
        "instructions": "Mix all together in a pitcher and refrigerate. Add partsoves and cinnamon sticks to taste. Serve in wine glasses.",
        "ingredients": [
            "Wine - Red",
            "Sugar",
            "Juice - Orange",
            "Juice - Lemon",
            "partsoves",
            "Cinnamon"
        ],
        "amounts": [
            "1 bottle",
            "1/2 cup",
            "1 cup",
            "1 cup"
        ]
    },
    {
        "id": 30,
        "name": "Abbey Martini",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/2mcozt1504817403.jpg",
        "glass": "Cocktail glass",
        "instructions": "Put all ingredients into a shaker and mix, then strain contents into a chilled cocktail glass.",
        "ingredients": [
            "Gin",
            "Sweet Vermouth",
            "Juice - Orange",
            "Bitters"
        ],
        "amounts": [
            "2 shots",
            "1 shot",
            "1 shot",
            "3 dashes"
        ]
    },
    {
        "id": 512,
        "name": "Vampiro",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yfhn371504374246.jpg",
        "glass": "Old-Fashioned glass",
        "instructions": "Vampiros may be made in a tall glass or an old fashioned glass. Bartenders may first \"rim\" the glass with Kosher Salt, which is done by placing a layer of Kosher Salt on a chopping board, moistening the glass' rim with lime juice or water, and then placing the upside down glass rim onto the Kosher Salt, so that the salt sticks to the moistened rim. The second step is to fill half the glass with ice and add one or two shooter glasses full of high quality Tequila. The next stage is to add the flavouring elements. This is done by squeezing a fresh lime into the glass, adding a few grains of salt, adding citrus-flavoured soda pop, until the glass is 4/5 full, and then adding spicy Viuda de Sanchez (or orange juice, lime juice and pico de gallo). The final step is to stir the ingredients so that the flavours are properly blended.",
        "ingredients": [
            "Tequila",
            "Tomato Juice",
            "Juice - Orange",
            "Juice - Lime",
            "Simple Syrup",
            "Salt"
        ],
        "amounts": [
            "6 parts",
            "3 parts",
            "3 parts",
            "1.5 parts",
            "1 dash",
            "1 pinch"
        ]
    },
    {
        "id": 278,
        "name": "Golden dream",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qrot6j1504369425.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake with cracked ice. Strain into glass and serve.",
        "ingredients": [
            "Galliano",
            "Triple Sec",
            "Juice - Orange",
            "Cream"
        ],
        "amounts": [
            "2 parts",
            "2 parts",
            "2 parts",
            "1 part"
        ]
    },
    {
        "id": 392,
        "name": "Orange Crush",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/zvoics1504885926.jpg",
        "glass": "Shot glass",
        "instructions": "Add all ingredients to tumbler-Pour as shot",
        "ingredients": [
            "Vodka",
            "Triple Sec",
            "Juice - Orange"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 503,
        "name": "Thriller",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rvuswq1461867714.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a cocktail glass.",
        "ingredients": [
            "Scotch",
            "Wine",
            "Juice - Orange"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz Green Ginger",
            "1 oz"
        ]
    },
    {
        "id": 136,
        "name": "Berry Deadly",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xqutpr1461867477.jpg",
        "glass": "Collins Glass",
        "instructions": "Add all ingredients to large bowl. Stir gently. Serve chilled.",
        "ingredients": [
            "Vodka",
            "Wine",
            "Juice - Orange",
            "Kool-Aid"
        ],
        "amounts": [
            "2 pint",
            "1 bottle Boone Strawberry Hill",
            "1/2 gal",
            "1 gal Tropical Berry"
        ]
    },
    {
        "id": 402,
        "name": "Pina Colada",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/cpf4j51504371346.jpg",
        "glass": "Collins glass",
        "instructions": "Mix with crushed ice in blender until smooth. Pour into chilled glass, garnish and serve.",
        "ingredients": [
            "Rum - Light",
            "Coconut Milk",
            "Juice - Pineapple"
        ],
        "amounts": [
            "3 oz",
            "3 tblsp",
            "3 tblsp"
        ]
    },
    {
        "id": 64,
        "name": "Algonquin",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/uwryxx1483387873.jpg",
        "glass": "Cocktail glass",
        "instructions": "Combine and shake all ingredients with ice, strain contents into a cocktail glass, and serve.",
        "ingredients": [
            "Whiskey",
            "Dry Vermouth",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 131,
        "name": "Barracuda",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/jwmr1x1504372337.jpg",
        "glass": "Margarita glass",
        "instructions": "Shake pour ingredients with ice. Strain into glass, top with Sparkling wine.",
        "ingredients": [
            "Rum",
            "Galliano",
            "Juice - Pineapple",
            "Juice - Lime",
            "Prosecco"
        ],
        "amounts": [
            "4.5 parts",
            "1.5 parts",
            "6 parts",
            "1 dash",
            "top up"
        ]
    },
    {
        "id": 524,
        "name": "Waikiki Beachcomber",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ysuqus1441208583.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Triple Sec",
            "Gin",
            "Juice - Pineapple"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "1 tblsp"
        ]
    },
    {
        "id": 474,
        "name": "Space Odyssey",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vxtjbx1504817842.jpg",
        "glass": "Highball glass",
        "instructions": "Fill glass with ice and add shots of rum and coconut rum. Add splash of pineapple juice and top with orange juice. Add grenadine for color and garnish with cherries.",
        "ingredients": [
            "Rum - Strong",
            "Rum - Coconunt",
            "Juice - Pineapple",
            "Juice - Orange",
            "Grenadine",
            "Cherries"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "1 shot"
        ]
    },
    {
        "id": 281,
        "name": "Grass Skirt",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qyvprp1473891585.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the gin, triple sec, pineapple juice, and grenadine. Shake well. Pour into an old-fashioned glass and garnish with the pineapple slice.",
        "ingredients": [
            "Gin",
            "Triple Sec",
            "Juice - Pineapple",
            "Grenadine",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1 oz",
            "1/2 tsp"
        ]
    },
    {
        "id": 290,
        "name": "Hawaiian Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ujoh9x1504882987.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Gin",
            "Triple Sec",
            "Juice - Pineapple"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "1 tblsp"
        ]
    },
    {
        "id": 63,
        "name": "Alfie Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ypxsqy1483387829.jpg",
        "glass": "Cocktail glass",
        "instructions": "Combine and shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Vodka - Citrus",
            "Triple Sec",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 dash",
            "1 tblsp"
        ]
    },
    {
        "id": 229,
        "name": "Duchamp's Punch",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/g51naw1485084685.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Shake all ingredients.\nDouble strain in a chilled double old fashioned glass with abig ice cube.\nGarnish with a couple of lavender sprigs",
        "ingredients": [
            "Pisco",
            "Juice - Lime",
            "Juice - Pineapple Syrup",
            "St. Germain",
            "Bitters",
            "Pepper",
            "Lavender"
        ],
        "amounts": [
            "5 parts",
            "2.5 parts",
            "2.5 parts",
            "1.5 parts",
            "2 Dashes",
            "Pinch",
            "2 sprigs"
        ]
    },
    {
        "id": 509,
        "name": "Turkeyball",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/rxurpr1441554292.jpg",
        "glass": "Shot glass",
        "instructions": "Shake with ice and strain into a shot glass.",
        "ingredients": [
            "Bourbon",
            "Amaretto",
            "Juice -Juice - Pineapple"
        ],
        "amounts": [
            "1 oz",
            "3/4 oz",
            "1 splash"
        ]
    },
    {
        "id": 456,
        "name": "Screaming Orgasm",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/x894cs1504388670.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour first vodka, then Bailey's, then Kahlua into a cocktail glass over crushed ice. Stir. Caution: use only high quality vodka. Cheap vodka can cause the Bailey's to curdle. Test your brand of vodka by mixing 1 Tsp each of vodka and Bailey's first.",
        "ingredients": [
            "Vodka",
            "Bailey's irish cream",
            "Kahlua"
        ],
        "amounts": [
            "1 oz",
            "1 1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 146,
        "name": "Blind Russian",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/wxuqvr1472720408.jpg",
        "glass": "Collins glass",
        "instructions": "Fill glass with ice. Add all liquers. Add milk. shake.",
        "ingredients": [
            "Bailey's irish cream",
            "Godiva liqueur",
            "Kahlua",
            "Liqueur - Butterscotch",
            "Milk"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "3/4 oz",
            "1/2 oz",
            "to fill"
        ]
    },
    {
        "id": 119,
        "name": "B-52",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/5a3vg61504372070.jpg",
        "glass": "Shot glass",
        "instructions": "Layer ingredients into a shot glass. Serve with a stirrer.",
        "ingredients": [
            "Bailey's irish cream",
            "Triple Sec",
            "Kahlua"
        ],
        "amounts": [
            "1/3",
            "1/3",
            "1/4"
        ]
    },
    {
        "id": 285,
        "name": "Grizzly Bear",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/k6v97f1487602550.jpg",
        "glass": "Collins Glass",
        "instructions": "Served over ice. Sounds nasty, but tastes great.",
        "ingredients": [
            "Amaretto",
            "Jägermeister",
            "Kahlua",
            "Milk"
        ],
        "amounts": [
            "1 part",
            "1 part",
            "1 part",
            "2 1/2 parts"
        ]
    },
    {
        "id": 541,
        "name": "Zippy's Revenge",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/1sqm7n1485620312.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Mix Kool-Aid to taste then add Rum and ammaretto. shake well to disolve the sugar in the Kool-Aid... serve cold",
        "ingredients": [
            "Amaretto",
            "Rum",
            "Kool-Aid"
        ],
        "amounts": [
            "2 oz",
            "2 oz",
            "4 oz Grape"
        ]
    },
    {
        "id": 68,
        "name": "Allies Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qvprvp1483388104.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain contents into a cocktail glass, and serve.",
        "ingredients": [
            "Dry Vermouth",
            "Gin",
            "Kummel"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1/2 tsp"
        ]
    },
    {
        "id": 250,
        "name": "Frisco Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/y39l941504884150.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake all ingredients (except slices of lemon and lime) with ice and strain into a whiskey sour glass. Decorate with the slices of lemon and lime and serve.",
        "ingredients": [
            "Whiskey",
            "Benedictine",
            "Lemon",
            "Lime",
            "Lemon",
            "Lime"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "Juice of 1/4",
            "Juice of 1/2",
            "1 slice",
            "1 slice"
        ]
    },
    {
        "id": 303,
        "name": "Imperial Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/zj1usl1504884548.jpg",
        "glass": "Highball glass",
        "instructions": "Shake all ingredients (except carbonated water) with ice and strain into a highball glass over two ice cubes. Fill with carbonated water, stir, and serve.",
        "ingredients": [
            "Rum - Light",
            "Whiskey",
            "Lemon",
            "Sugar",
            "Water - Soda"
        ],
        "amounts": [
            "1/2 oz",
            "1 1/2 oz",
            "Juice of 1/2",
            "1 tsp"
        ]
    },
    {
        "id": 417,
        "name": "Quaker's Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yrqppx1478962314.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Rum - Light",
            "Brandy",
            "Lemon",
            "Raspberry syrup"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "Juice of 1/4",
            "2 tsp"
        ]
    },
    {
        "id": 345,
        "name": "Lemon Shot",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/mx31hv1487602979.jpg",
        "glass": "Shot glass",
        "instructions": "Mix Galliano and Absolut Citron in a shot glass, lay lemon wedge sprinkled with sugar over glass and pour a rum over wedge and glass. light rum with a lighter and let burn for a second. Do shot quickly and suck on lemon. If it is done correctly, this will taste like a shot of sweet lemonade.",
        "ingredients": [
            "Galliano",
            "Citrus Vodka",
            "Lemon",
            "Sugar",
            "Rum - Strong"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "wedge",
            ""
        ]
    },
    {
        "id": 168,
        "name": "Brandy Cobbler",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vtvutr1439465836.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In an old-fashioned glass, dissolve the sugar in the partsub soda. Add crushed ice until the glass is almost full. Add the brandy. Stir well. Garnish with the cherry and the orange and lemon slices.",
        "ingredients": [
            "Sugar",
            "partsub soda",
            "Lemon",
            "Brandy",
            "Cherry",
            "Orange"
        ],
        "amounts": [
            "1 tsp superfine",
            "3 oz",
            "2 oz"
        ]
    },
    {
        "id": 436,
        "name": "Rum Cobbler",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/5vh9ld1504390683.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In an old-fashioned glass, dissolve the sugar in the partsub soda. Add crushed ice until the glass is almost full. Add the rum. Stir well. Garnish with the cherry and the orange and lemon slices.",
        "ingredients": [
            "Sugar",
            "partsub soda",
            "Lemon",
            "Dark rum",
            "Cherry",
            "Orange"
        ],
        "amounts": [
            "1 tsp superfine",
            "3 oz",
            "2 oz"
        ]
    },
    {
        "id": 344,
        "name": "Lemon Drop",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/mtpxgk1504373297.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake and strain into a chilled cocktail glass rimmed with sugar.",
        "ingredients": [
            "Vodka",
            "Triple Sec",
            "Lemon"
        ],
        "amounts": [
            "1 1/2 shot",
            "1 1/2 shot",
            "Juice of 1 wedge"
        ]
    },
    {
        "id": 266,
        "name": "Gin Rickey",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/s00d6f1504883945.jpg",
        "glass": "Highball glass",
        "instructions": "Half-fill a tall glass with ice. Mix the gin and Grenadine together and pour over the ice. Add the lime or lemon juice and top off with soda water. Decorate the glass with lime and/or lemon slices.",
        "ingredients": [
            "Gin",
            "Grenadine",
            "lemon",
            "Water - Soda",
            "Lime"
        ],
        "amounts": [
            "2 oz",
            "1 tsp",
            "Juice of 1/2",
            "Top up with",
            "Garnish"
        ]
    },
    {
        "id": 202,
        "name": "partsover partsub",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/t0aja61504348715.jpg",
        "glass": "Cocktail glass",
        "instructions": "Dry shake ingredients to emulsify, add ice, shake and served straight up.",
        "ingredients": [
            "Gin",
            "Grenadine",
            "Lemon",
            "Egg white"
        ],
        "amounts": [
            "1 1/2 oz",
            "2 tsp",
            "Juice of 1/2"
        ]
    },
    {
        "id": 437,
        "name": "Rum Cooler",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/2hgwsb1504888674.jpg",
        "glass": "Collins glass",
        "instructions": "Pour the rum and soda into a collins glass almost filled with ice cubes. Stir well and garnish with the lemon wedge.",
        "ingredients": [
            "Rum",
            "Sprite",
            "Lemon"
        ],
        "amounts": [
            "2 oz light or dark",
            "4 oz"
        ]
    },
    {
        "id": 192,
        "name": "Chicago Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qwvwqr1441207763.jpg",
        "glass": "Highball glass",
        "instructions": "Shake all ingredients (except carbonated water) with ice and strain into a highball glass over two ice cubes. Fill with carbonated water, stir, and serve.",
        "ingredients": [
            "Rum - Light",
            "Port",
            "Lemon",
            "Sugar",
            "Egg white",
            "Water - Soda"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "Juice of 1/2",
            "1 tsp"
        ]
    },
    {
        "id": 450,
        "name": "Sangria - The World's Best",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vysywu1468924264.jpg",
        "glass": "Pitcher",
        "instructions": "Mix wine, sugar and fruit, and let sit in the fridge for 18-24 hours. The mixture will have a somewhat syrupy consistency. Before serving stir in brandy and cut the mixture with soda water until it have a thinner, more wine like consistency. Serve from a pitcher in wine glasses.",
        "ingredients": [
            "Wine - Red",
            "Sugar",
            "Lemon",
            "Orange",
            "Apple",
            "Brandy",
            "Water - Soda"
        ],
        "amounts": [
            "1 1/2 L",
            "1 cup",
            "1 large",
            "1 large",
            "1 large",
            "3-4 oz plain"
        ]
    },
    {
        "id": 516,
        "name": "Vesuvio",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/26cq601492976203.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Shake all ingredients with ice, strain into an old-fashioned glass over ice cubes, and serve.",
        "ingredients": [
            "Rum - Light",
            "Sweet Vermouth",
            "Lemon",
            "Sugar",
            "Egg white"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "Juice of 1/2",
            "1 tsp"
        ]
    },
    {
        "id": 466,
        "name": "Sidecar Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ewjxui1504820428.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Brandy",
            "Triple Sec",
            "Lemon"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "Juice of 1/4"
        ]
    },
    {
        "id": 400,
        "name": "Owen's Grandmother's Revenge",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/0wt4uo1503565321.jpg",
        "glass": "Highball glass",
        "instructions": "Add ingredients and mix in blender.",
        "ingredients": [
            "Whiskey",
            "Beer",
            "Lemonade",
            "Ice"
        ],
        "amounts": [
            "12 oz",
            "12 oz",
            "12 oz frozen",
            "1 cup crushed"
        ]
    },
    {
        "id": 149,
        "name": "Blue Lagoon",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vak0e51504389504.jpg",
        "glass": "Highball glass",
        "instructions": "Pour vodka and curacao over ice in a highball glass. Fill with lemonade, top with the cherry, and serve.",
        "ingredients": [
            "Vodka",
            "Triple Sec",
            "Lemonade",
            "Cherry"
        ],
        "amounts": [
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 515,
        "name": "Vesper",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/mtdxpa1504374514.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake over ice until well chilled, then strain into a deep goblet and garnish with a thin slice of lemon peel.",
        "ingredients": [
            "Gin",
            "Vodka",
            "Lillet Blanc"
        ],
        "amounts": [
            "6 parts",
            "1.5 parts",
            "0.75 parts"
        ]
    },
    
    {
        "id": 181,
        "name": "California Lemonade",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qvvxwy1472406424.jpg",
        "glass": "Collins glass",
        "instructions": "Shake all ingredients (except carbonated water) with ice and strain into a collins glass over shaved ice. Fill with carbonated water and stir. Decorate with slices of orange and lemon. Add the cherry and serve with a straw.",
        "ingredients": [
            "Whiskey",
            "Lemon",
            "Lime",
            "Sugar",
            "Grenadine",
            "Water - Soda"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1",
            "Juice of 1",
            "1 tblsp",
            "1/4 tsp"
        ]
    },
    {
        "id": 418,
        "name": "Quarter Deck Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qrwvps1478963017.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Rum - Light",
            "Sherry",
            "Lime"
        ],
        "amounts": [
            "1 1/2",
            "1/3 oz cream",
            "Juice of 1/2"
        ]
    },
    {
        "id": 262,
        "name": "Gin And Tonic",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wtyxvx1472405831.jpg",
        "glass": "Highball glass",
        "instructions": "Pour the gin and the tonic water into a highball glass almost filled with ice cubes. Stir well. Garnish with the lime wedge.",
        "ingredients": [
            "Gin",
            "Water - Tonic",
            "Lime"
        ],
        "amounts": [
            "2 oz",
            "5 oz"
        ]
    },
    {
        "id": 54,
        "name": "After Dinner Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vtytxq1483387578.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients (except lime wedge) with ice and strain into a cocktail glass. Add the wedge of lime and serve.",
        "ingredients": [
            "Brandy",
            "Triple Sec",
            "Lime",
            "Lime"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "Juice of 1"
        ]
    },
    {
        "id": 138,
        "name": "Bible Belt",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/6bec6v1503563675.jpg",
        "glass": "Highball glass",
        "instructions": "Mix all ingredients, and pour over ice.",
        "ingredients": [
            "Southern Comfort",
            "Triple Sec",
            "Lime",
            "Sour mix"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "2 wedges",
            "2 oz"
        ]
    },
    {
        "id": 207,
        "name": "Cosmopolitan Martini",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/upxxpq1439907580.jpg",
        "glass": "Cocktail Glass",
        "instructions": "Pour all ingredients in mixing glass half filled with ice, shake and strain into chilled Martini glass.",
        "ingredients": [
            "Triple Sec",
            "Vodka",
            "Lime",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1/2 oz",
            "1 oz",
            "Juice of 1/2",
            "1 splash"
        ]
    },
    {
        "id": 510,
        "name": "Tuxedo Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/4u0nbl1504352551.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice and strain into a cocktail glass. Garnish with a cherry and a twist lemon zest.",
        "ingredients": [
            "Dry Vermouth",
            "Gin",
            "Liqueur - Cherry",
            "Anis",
            "Bitters",
            "Cherry"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 1/2 oz",
            "1/4 tsp",
            "1/4 tsp",
            "2 dashes"
        ]
    },
    {
        "id": 291,
        "name": "Hemingway Special",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/jfcvps1504369888.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into a shaker with ice. Shake.",
        "ingredients": [
            "Rum",
            "Grapefruit Juice",
            "Liqueur - Cherry",
            "Juice - Lime"
        ],
        "amounts": [
            "12 parts",
            "8 parts",
            "3 parts",
            "3 parts"
        ]
    },
    {
        "id": 117,
        "name": "Aviation",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/ruutxt1478253328.jpg",
        "glass": "Cocktail glass",
        "instructions": "Add all ingredients into cocktail shaker filled with ice. Shake well and strain into cocktail glass. Garnish with a cherry.",
        "ingredients": [
            "Gin",
            "Juice - Lemon",
            "Liqueur - Cherry"
        ],
        "amounts": [
            "4.5 parts",
            "1.5 parts",
            "1.5 parts"
        ]
    },
    {
        "id": 187,
        "name": "Casino Royale",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3qpv121504366699.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into a sour glass.",
        "ingredients": [
            "Gin",
            "Juice - Lemon",
            "Liqueur - Cherry",
            "Bitters",
            "Egg yolk"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "1 tsp",
            "1 dash"
        ]
    },
    {
        "id": 365,
        "name": "Mary Pickford",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/f9erqb1504350557.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake and strain into a chilled large cocktail glass",
        "ingredients": [
            "Rum - Light",
            "Juice - Pineapple",
            "Liqueur - Cherry",
            "Grenadine",
            "Cherry"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1/2 tsp",
            "1/2 tsp"
        ]
    },
    {
        "id": 20,
        "name": "A Splash of Nash",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/rsvtrr1472668201.jpg",
        "glass": "Highball glass",
        "instructions": "Drop shot glass with banana & melon liquers into a 9 oz hi- ball glass containing soda water and cranberry juice. Drink in one shot.",
        "ingredients": [
            "Juice - Cranberry",
            "Water - Soda",
            "Liqueur - Melon",
            "Creme de Banane"
        ],
        "amounts": [
            "2 oz",
            "2 oz",
            "0.5 oz",
            "0.5 oz"
        ]
    },
    {
        "id": 84,
        "name": "Amaretto Sweet & Sour",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vswwus1472668546.jpg",
        "glass": "Margarita/Coupette glass",
        "instructions": "Fill the blender with 3/4 ice. Add sweet & sour mix to the top of the ice. Add about 1\" of pineapple juice, 1/2\" of melon liqeur, and 1/2 to 1/4\" of amaretto. Then blend the mix until it is of margaritta consistency or thinner.",
        "ingredients": [
            "Amaretto",
            "Sweet and sour",
            "Liqueur - Melon",
            "Juice - Pineapple"
        ],
        "amounts": []
    },
    {
        "id": 1,
        "name": "1-900-FUK-MEUP",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/uxywyw1468877224.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Shake ingredients in a mixing tin filled with ice cubes. Strain into a rocks glass.",
        "ingredients": [
            "Vodka - Berry",
            "Triple Sec",
            "Liqueur - Raspberry",
            "Liqueur - Melon",
            "Rum - Coconunt",
            "Amaretto",
            "Juice - Cranberry",
            "Juice - Pineapple"
        ],
        "amounts": [
            "1/2 oz",
            "1/4 oz",
            "1/4 oz",
            "1/4 oz",
            "1/4 oz",
            "1/4 oz",
            "1/2 oz",
            "1/4 oz"
        ]
    },
    {
        "id": 433,
        "name": "Royal Flush",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/7rnm8u1504888527.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour all the ingredients into tumbler over ice. Strain into glass.",
        "ingredients": [
            "Whiskey",
            "Peach schnapps",
            "Liqueur - Raspberry",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1/2 oz",
            "1 oz"
        ]
    },
    {
        "id": 382,
        "name": "Mother's Milk",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/7stuuh1504885399.jpg",
        "glass": "Shot glass",
        "instructions": "Shake over ice, strain. Serves two.",
        "ingredients": [
            "Goldschlager",
            "Liqueur - Butterscotch",
            "Milk"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 177,
        "name": "Butter Baby",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/1xhjk91504783763.jpg",
        "glass": "Beer mug",
        "instructions": "Blend together in a blender. Serve in a chilled Beer mug with Fresh Blueberries and caramel for topping.",
        "ingredients": [
            "Vanilla Ice-Cream",
            "Liqueur - Butterscotch",
            "Milk",
            "Vodka"
        ],
        "amounts": [
            "2 scoops",
            "1 part",
            "full glass",
            "2 parts"
        ]
    },
    {
        "id": 390,
        "name": "Nutty Irishman",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/xspupx1441248014.jpg",
        "glass": "Highball Glass",
        "instructions": "Serve over ice",
        "ingredients": [
            "Bailey's irish cream",
            "Frangelico",
            "Milk"
        ],
        "amounts": [
            "1 part",
            "1 part",
            "1 part"
        ]
    },
    {
        "id": 306,
        "name": "Irish Cream",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/90etyl1504884699.jpg",
        "glass": "Irish coffee cup",
        "instructions": "Mix scotch and milk. Add half-and-half. Add rest.",
        "ingredients": [
            "Scotch",
            "Half-and-half",
            "Milk",
            "Coconut syrup",
            "Chocolate syrup"
        ],
        "amounts": [
            "1 cup",
            "1 1/4 cup",
            "1 can sweetened",
            "3 drops",
            "1 tblsp"
        ]
    },
    {
        "id": 252,
        "name": "Frozen Mint Daiquiri",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/jrhn1q1504884469.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Combine all ingredients with 1 cup of crushed ice in an electric blender. Blend at a low speed for a short length of time. Pour into an old-fashioned glass and serve.",
        "ingredients": [
            "Rum - Light",
            "Juice - Lime",
            "Mint",
            "Sugar"
        ],
        "amounts": [
            "2 oz",
            "1 tblsp",
            "1 tsp"
        ]
    },
    {
        "id": 220,
        "name": "Derby",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/i502ra1504349156.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into a mixing glass with ice. Stir. Strain into a cocktail glass. Garnish with a sprig of fresh mint in the drink.",
        "ingredients": [
            "Gin",
            "Peach Bitters",
            "Mint"
        ],
        "amounts": [
            "6 parts",
            "2 dashes",
            "2 Fresh leaves"
        ]
    },
    {
        "id": 163,
        "name": "Brain Fart",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rz5aun1504389701.jpg",
        "glass": "Punch bowl",
        "instructions": "Mix all ingredients together. Slowly and gently. Works best if ice is added to punch bowl and soda's are very cold.",
        "ingredients": [
            "Vodka",
            "Mountain Dew",
            "Energy Drink",
            "Juice - Lemon",
            "Rum"
        ],
        "amounts": [
            "1 fifth",
            "2 L",
            "2 L",
            "1 small bottle",
            "1 pint"
        ]
    },
    {
        "id": 364,
        "name": "Martini",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/71t8581504353095.jpg",
        "glass": "Cocktail glass",
        "instructions": "Straight: Pour all ingredients into mixing glass with ice cubes. Stir well. Strain in chilled martini cocktail glass. Squeeze oil from lemon peel onto the drink, or garnish with olive.",
        "ingredients": [
            "Gin",
            "Dry Vermouth",
            "Olive"
        ],
        "amounts": [
            "1 2/3 oz",
            "1/3 oz"
        ]
    },
    {
        "id": 522,
        "name": "Vodka Martini",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qyxrqw1439906528.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake the vodka and vermouth together with a number of ice cubes, strain into a cocktail glass, add the olive and serve.",
        "ingredients": [
            "Vodka",
            "Dry Vermouth",
            "Olive"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 222,
        "name": "Dirty Martini",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/vcyvpq1485083300.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour the vodka, dry vermouth and olive brine into a cocktail shaker with a handful of ice and shake well.\nRub the rim of a martini glass with the wedge of lemon.\nStrain the contents of the cocktail shaker into the glass and add the olive.\nA dirty Martini contains a splash of olive brine or olive juice and is typically garnished with an olive.",
        "ingredients": [
            "Vodka",
            "Dry Vermouth",
            "Olive Brine",
            "Lemon",
            "Olive"
        ],
        "amounts": [
            "70ml/2fl oz",
            "1 tbsp",
            "2 tbsp",
            "1 wedge"
        ]
    },
    {
        "id": 29,
        "name": "Abbey Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/quyyuw1472811568.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients (except for the cherry) with ice and strain into a cocktail glass. Top with the cherry and serve.",
        "ingredients": [
            "Gin",
            "Bitters",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 dash",
            "Juice of 1/4"
        ]
    },
    {
        "id": 111,
        "name": "Atlantic Sun",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/doyxqb1493067556.jpg",
        "glass": "Collins Glass",
        "instructions": "Shake all the ingredients, top the drink with soda. Garnish with a slice of orange.",
        "ingredients": [
            "Vodka",
            "Southern Comfort",
            "Passion fruit syrup",
            "Sweet and sour",
            "partsub soda"
        ],
        "amounts": [
            "2 parts Smirnoff",
            "2 parts",
            "2 parts",
            "6 parts",
            "1 dash"
        ]
    },
    {
        "id": 134,
        "name": "Bellini Martini",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3h9wv51504389379.jpg",
        "glass": "Cocktail glass",
        "instructions": "Add ice cubes to shaker.\nAdd vodka.\nAdd peach schnapps.\nAdd peach nectar.\nShake.\nStrain into glass.\nAdd lemon twist peel.",
        "ingredients": [
            "Vodka",
            "Peach nectar",
            "Peach schnapps",
            "Peel - Lemon"
        ],
        "amounts": [
            "3 oz",
            "1.5 oz",
            "1.5 oz"
        ]
    },
    {
        "id": 407,
        "name": "Pink Penocha",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/6vigjx1503564007.jpg",
        "glass": "Punch bowl",
        "instructions": "mix all ingredients into bowl keep iced stir frequently",
        "ingredients": [
            "Vodka",
            "Peach schnapps",
            "Juice - Orange",
            "Juice - Cranberry"
        ],
        "amounts": [
            "750 ml",
            "750 ml",
            "1 gal",
            "1 gal"
        ]
    },
    {
        "id": 173,
        "name": "Bruised Heart",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/7if5kq1503564209.jpg",
        "glass": "Shot glass",
        "instructions": "Pour all ingredients in a mixing tin over ice, stir, and strain into shot glass",
        "ingredients": [
            "Vodka",
            "Liqueur - Raspberry",
            "Peachtree schnapps",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 326,
        "name": "Kentucky Colonel",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/utqwpu1478820348.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a shaker half-filled with ice cubes combine the courbon and Benedictine. Shake and strain into a cocktail glass. Garnish with the lemon twist.",
        "ingredients": [
            "Bourbon",
            "Benedictine",
            "Peel - Lemon"
        ],
        "amounts": [
            "3 oz",
            "1/2 oz",
            "1 twist"
        ]
    },
    {
        "id": 446,
        "name": "Rusty Nail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yqsvtw1478252982.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour the Scotch and Drambuie into an old-fashioned glass almost filled with ice cubes. Stir well. Garnish with the lemon twist.",
        "ingredients": [
            "Scotch",
            "Drambuie",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1 twist"
        ]
    },
    {
        "id": 227,
        "name": "Dry Rob Roy",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/typuyq1439456976.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with ice cubes, combine the Scotch and vermouth. Stir well. Strain into a cocktail glass. Garnish with the lemon twist.",
        "ingredients": [
            "Scotch",
            "Dry Vermouth",
            "Peel - Lemon"
        ],
        "amounts": [
            "2 1/2 oz",
            "1 1/2 tsp",
            "1 twist"
        ]
    },
    {
        "id": 16,
        "name": "A Furlong Too Late",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ssxvww1472669166.jpg",
        "glass": "Highball glass",
        "instructions": "Pour the rum and ginger beer into a highball glass almost filled with ice cubes. Stir well. Garnish with the lemon twist.",
        "ingredients": [
            "Rum - Light",
            "Ginger beer",
            "Peel - Lemon"
        ],
        "amounts": [
            "2 oz",
            "4 oz",
            "1 twist"
        ]
    },
    {
        "id": 444,
        "name": "Rum Toddy",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/athdk71504886286.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Dissolve powdered sugar in water in an old-fashioned glass. Add rum and one ice cube and stir. Add the twist lemon peel and serve.",
        "ingredients": [
            "Rum",
            "Sugar",
            "Peel - Lemon",
            "Water"
        ],
        "amounts": [
            "2 oz light or dark",
            "2 tsp",
            "1 twist",
            "2 tsp"
        ]
    },
    {
        "id": 144,
        "name": "Blackthorn",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xvswvy1441209430.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir sloe gin and vermouth with ice and strain into a cocktail glass. Add the twist lemon peel and serve.",
        "ingredients": [
            "Sweet Vermouth",
            "Gin",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 oz",
            "1 1/2 oz",
            "1 twist"
        ]
    },
    {
        "id": 383,
        "name": "Mudslinger",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/hepk6h1504885554.jpg",
        "glass": "Punch bowl",
        "instructions": "Add all contents to a large jug or punch bowl. Stir well!",
        "ingredients": [
            "Southern Comfort",
            "Juice - Orange",
            "Pepsi Cola"
        ],
        "amounts": [
            "750 ml",
            "1 L",
            "750 ml"
        ]
    },
    {
        "id": 469,
        "name": "Smut",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rx8k8e1504365812.jpg",
        "glass": "Beer mug",
        "instructions": "Throw it all together and serve real cold.",
        "ingredients": [
            "Wine - Red",
            "Peach schnapps",
            "Pepsi Cola",
            "Juice - Orange"
        ],
        "amounts": [
            "1/3 part",
            "1 shot",
            "1/3 part",
            "1/3 part"
        ]
    },
    {
        "id": 451,
        "name": "Sazerac",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vvpxwy1439907208.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Rinse a chilled old-fashioned glass with the absinthe, add crushed ice, and set it aside. Stir the remaining ingredients over ice and set it aside. Discard the ice and any excess absinthe from the prepared glass, and strain the drink into the glass. Add the lemon peel for garnish.",
        "ingredients": [
            "Ricard",
            "Sugar",
            "Peychaud bitters",
            "Water",
            "Bourbon",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 tsp",
            "1/2 tsp superfine",
            "2 dashes",
            "1 tsp",
            "2 oz",
            "1 twist"
        ]
    },
    {
        "id": 110,
        "name": "Artillery Punch",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/9a4vqb1493067692.jpg",
        "glass": "Punch bowl",
        "instructions": "Combine all the ingredients in a large punch bowl with a block of ice. If found too dry, sugar syrup may be added. Decorate with twists of lemon peel.",
        "ingredients": [
            "Tea",
            "Rye whiskey",
            "Red wine",
            "Rum",
            "Brandy",
            "Benedictine",
            "Juice - Orange",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 quart black",
            "1 quart",
            "1 fifth",
            "1 pint Jamaican",
            "1/2 pint",
            "1 1/2 oz",
            "1 pint",
            "1/2 pint"
        ]
    },
    {
        "id": 118,
        "name": "Aztec Punch",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/uqwuyp1454514591.jpg",
        "glass": "Punch bowl",
        "instructions": "Mix all ingredients in a pitcher. Mix thoroughly and pour into whatever is available, the bigger the better! This drink packs a big punch, so don't over do it.",
        "ingredients": [
            "Lemonade",
            "Vodka",
            "Rum",
            "Ginger ale"
        ],
        "amounts": [
            "1 can",
            "5 oz",
            "7 oz",
            "About 1 bottle"
        ]
    },
    {
        "id": 502,
        "name": "The Evil Blue Thing",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/ojnpz71504793059.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour ingredients into glass, and drop in a blue whale! The blue whale isn't really necessary, but it makes the drink more \"fun\".",
        "ingredients": [
            "Creme de Cacao",
            "Triple Sec",
            "Rum - Light"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 353,
        "name": "Long Island Iced Tea",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wx7hsg1504370510.jpg",
        "glass": "Highball glass",
        "instructions": "Mix all contents in a highball glass and sitr gently. Add dash of Coca-Cola for the coloring and garnish with lemon or lime twist.",
        "ingredients": [
            "Vodka",
            "Tequila",
            "Rum - Light",
            "Gin",
            "Coke",
            "Peel - Lemon"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1 dash",
            "twist"
        ]
    },
    {
        "id": 3,
        "name": "151 Florida Bushwacker",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/rvwrvv1468877323.jpg",
        "glass": "Beer mug",
        "instructions": "Combine all ingredients. Blend until smooth. Garnish with chocolate shavings if desired.",
        "ingredients": [
            "Rum - Cocounut",
            "Rum - Light",
            "Rum - Strong",
            "Dark Creme de Cacao",
            "Triple Sec",
            "Milk",
            "Coconut liqueur",
            "Vanilla ice-cream"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1 oz",
            "1 oz",
            "3 oz",
            "1 oz",
            "1 cup"
        ]
    },
    {
        "id": 238,
        "name": "Flaming Dr. Pepper",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/d30z931503565384.jpg",
        "glass": "Collins Glass",
        "instructions": "Add Amaretto, rum, and vodka. Mix in the Dr. Pepper and beer",
        "ingredients": [
            "Amaretto",
            "Vodka",
            "Rum - Strong",
            "Dr. Pepper",
            "Beer"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 5,
        "name": "24k nightmare",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/yyrwty1468877498.jpg",
        "glass": "Shot glass",
        "instructions": "Add over ice,shake and pour.",
        "ingredients": [
            "Goldschlager",
            "Jägermeister",
            "Rumple Minze",
            "Rum - Strong"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 447,
        "name": "Salty Dog",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/4vfge01504890216.jpg",
        "glass": "Highball glass",
        "instructions": "Pour all ingredients over ice cubes in a highball glass. Stir well and serve. (Vodka may be substituted for gin, if preferred.)",
        "ingredients": [
            "Juice - Grapefruit",
            "Vodka",
            "Salt"
        ],
        "amounts": [
            "5 oz",
            "1 1/2 oz",
            "1/4 tsp"
        ]
    },
    {
        "id": 176,
        "name": "Bumble Bee #1",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/uwqpvv1461866378.jpg",
        "glass": "Shot glass",
        "instructions": "This is a layered shot. First pour the Bailey's into the shot glass. Then take an upside down spoon and touch it to the inside wall of the glass. Carefully add the Kahlua. Repeat this process for the Sambuca. If done properly, the alcohol will stay separated and resemble a bumble bee. Enjoy!!!",
        "ingredients": [
            "Bailey's irish cream",
            "Kahlua",
            "Sambuca"
        ],
        "amounts": [
            "1/3 oz",
            "1/3 oz",
            "1/3 oz"
        ]
    },
    {
        "id": 419,
        "name": "Queen Bee",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rvvpxu1478963194.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Brandy - Coffee",
            "Lime vodka",
            "Sherry"
        ],
        "amounts": [
            "1 oz",
            "1 1/2 oz",
            "1/2 oz cream"
        ]
    },
    {
        "id": 313,
        "name": "Jam Donut",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/uuytrp1474039804.jpg",
        "glass": "Shot glass",
        "instructions": "Coat the rim of a shot glass with sugar using sugar syrup to stick. Add the Chambord raspberry liqueur to the shot glass, and carefully layer the Baileys Irish Cream on top. Serve.",
        "ingredients": [
            "Baileys irish cream",
            "Liqueur - Raspberry",
            "Simple Syrup",
            "Sugar"
        ],
        "amounts": [
            "2/3 oz",
            "1/3 oz",
            "1 tsp",
            "2 pinches"
        ]
    },
    {
        "id": 445,
        "name": "Russian Spring Punch",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ctt20s1504373488.jpg",
        "glass": "Highball glass",
        "instructions": "Pour the ingredients into an highball glass, top with Sparkling wine.",
        "ingredients": [
            "Vodka",
            "Creme de Cassis",
            "Simple Syrup",
            "Juice - Lemon"
        ],
        "amounts": [
            "2.5 parts",
            "1.5 parts",
            "1 parts",
            "2.5 parts"
        ]
    },
    {
        "id": 236,
        "name": "Espresso Martini",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/n0sx531504372951.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour ingredients into shaker filled with ice, shake vigorously, and strain into chilled martini glass",
        "ingredients": [
            "Vodka",
            "Kahlua",
            "Simple Syrup"
        ],
        "amounts": [
            "5 parts",
            "1 parts",
            "1 dash"
        ]
    },
    {
        "id": 165,
        "name": "Bramble",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/lvzl3r1504372526.jpg",
        "glass": "Old-Fashioned glass",
        "instructions": "Fill glass with crushed ice. Build gin, lemon juice and simple syrup over. Stir, and then pour blackberry liqueur over in a circular fashion to create marbling effect. Garnish with two blackberries and lemon slice.",
        "ingredients": [
            "Gin",
            "Juice - Lemon",
            "Simple Syrup",
            "Creme de Mure"
        ],
        "amounts": [
            "4 parts",
            "1.5 parts",
            "1 parts",
            "1.5 parts"
        ]
    },
    {
        "id": 123,
        "name": "Bacardi Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/n433t21504348259.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake together with ice. Strain into glass and serve.",
        "ingredients": [
            "Rum - Light",
            "Juice - Lime",
            "Simple Syrup",
            "Grenadine"
        ],
        "amounts": [
            "1 3/4 oz",
            "1 oz",
            "1/2 tsp",
            "1 dash"
        ]
    },
    {
        "id": 97,
        "name": "Applejack",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/sutyqp1479209062.jpg",
        "glass": "Cocktail glass",
        "instructions": "Add all ingredients into mixing glass, chill and strain into cocktail glass",
        "ingredients": [
            "Bourbon",
            "Liqueur - Melon",
            "Sour mix"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "2 oz"
        ]
    },
    {
        "id": 497,
        "name": "Texas Rattlesnake",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/rtohqp1504889750.jpg",
        "glass": "Highball glass",
        "instructions": "Mix all ingredients and Shake well. Sweet at first, with a BITE at the end...",
        "ingredients": [
            "Bourbon",
            "Brandy",
            "Southern Comfort",
            "Sweet and sour"
        ],
        "amounts": [
            "1 part",
            "1/2 part",
            "1 part",
            "1 splash"
        ]
    },
    {
        "id": 66,
        "name": "Alice in Wonderland",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/g12lj41493069391.jpg",
        "glass": "Collins Glass",
        "instructions": "Just mix the three ingredients one to one to one",
        "ingredients": [
            "Amaretto",
            "Triple Sec",
            "Southern Comfort"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "1 shot"
        ]
    },
    {
        "id": 420,
        "name": "Queen Charlotte",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vqruyt1478963249.jpg",
        "glass": "Collins glass",
        "instructions": "Pour red wine and grenadine into a collins glass over ice cubes. Fill with lemon-lime soda, stir, and serve.",
        "ingredients": [
            "Wine - Red",
            "Grenadine",
            "Sprite"
        ],
        "amounts": [
            "2 oz",
            "1 oz"
        ]
    },
    {
        "id": 36,
        "name": "Absolut Summertime",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/trpxxs1472669662.jpg",
        "glass": "Collins glass",
        "instructions": "Add all ingredients except lemon to shaker filled with ice. Cover and shake vigorously. Strain contents into ice filled collins glass. Garnish with lemon.",
        "ingredients": [
            "Vodka - Citrus",
            "Sweet and sour",
            "Sprite",
            "Water - Soda",
            "Lemon"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz",
            "1/2 oz",
            "3 oz",
            "1 slice"
        ]
    },
    {
        "id": 22,
        "name": "A midsummernight dream",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ysqvqp1461867292.jpg",
        "glass": "Collins Glass",
        "instructions": "Mix the strawberrys in a blender Pour it together with the vodka,kirch and strawberry liquer over ice in a shaker. Shake well and pour in a highballglass. Fill up with the Russchian water",
        "ingredients": [
            "Vodka",
            "Kirschwasser",
            "Strawberry liqueur",
            "Strawberries",
            "Schweppes Russchian"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1 tsp"
        ]
    },
    {
        "id": 14,
        "name": "9 1/2 Weeks",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/xvwusr1472669302.jpg",
        "glass": "Cocktail glass",
        "instructions": "Combine all ingredients in glass mixer. Chill and strain into Cocktail glass. Garnish with sliced strawberry.",
        "ingredients": [
            "Vodka - Citrus",
            "Orange Triple Sec",
            "Strawberry liqueur",
            "Juice - Orange"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz",
            "1 splash",
            "1 oz"
        ]
    },
    {
        "id": 439,
        "name": "Rum Old-fashioned",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/otn2011504820649.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Stir powdered sugar, water, and bitters in an old-fashioned glass. When sugar has dissolved add ice cubes and light rum. Add the twist lime peel, float 151 proof rum on top, and serve.",
        "ingredients": [
            "Rum - Light",
            "Rum - Strong",
            "Sugar",
            "Bitters",
            "Water",
            "Peel - Lime"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 tsp",
            "1/2 tsp",
            "1 dash",
            "1 tsp",
            "twist"
        ]
    },
    {
        "id": 391,
        "name": "Old Fashioned",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/vrwquq1478252802.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Place sugar cube in old fashioned glass and saturate with bitters, add a dash of plain water. Muddle until dissolved.\nFill the glass with ice cubes and add whiskey.\n\nGarnish with orange twist, and a cocktail cherry.",
        "ingredients": [
            "Bourbon",
            "Bitters",
            "Sugar",
            "Water"
        ],
        "amounts": [
            "4.5 parts",
            "2 dashes",
            "1 cube",
            "dash"
        ]
    },
    {
        "id": 487,
        "name": "Swedish Coffee",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/ywtrvt1441246783.jpg",
        "glass": "Coffee Mug",
        "instructions": "Pour the coffee in an ordinary coffee cup. Add the aquavit. Add sugar by taste. Stir and have a nice evening (morning)",
        "ingredients": [
            "Coffee",
            "Aquavit",
            "Sugar"
        ],
        "amounts": [
            "1 cup",
            "4 parts",
            "By taste"
        ]
    },
    {
        "id": 263,
        "name": "Gin Cooler",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wsyrvv1478820109.jpg",
        "glass": "Collins glass",
        "instructions": "Stir powdered sugar and 2 oz. carbonated water in a collins glass. Fill glass with ice and add gin. Fill with carbonated water and stir. Add the lemon peel and the orange spiral so that the end of the orange spiral dangles over rim of glass.",
        "ingredients": [
            "Gin",
            "Water - Soda",
            "Sugar",
            "Orange spiral",
            "Peel - Lemon"
        ],
        "amounts": [
            "2 oz"
        ]
    },
    {
        "id": 268,
        "name": "Gin Smash",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/hp41fi1504883656.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Muddle sugar with carbonated water and mint sprigs in an old-fashioned glass. Add gin and 1 ice cube. Stir, add the orange slice and the cherry, and serve.",
        "ingredients": [
            "Gin",
            "Water - Soda",
            "Sugar",
            "Mint",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1 cube",
            "1 slice"
        ]
    },
    {
        "id": 305,
        "name": "Irish Coffee",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/sywsqw1439906999.jpg",
        "glass": "Irish coffee cup",
        "instructions": "Heat the coffee, whiskey and sugar; do not boil. Pour into glass and top with cream; serve hot.",
        "ingredients": [
            "Whiskey - Irish",
            "Coffee",
            "Sugar",
            "Whipped cream"
        ],
        "amounts": [
            "1 1/2 oz",
            "8 oz",
            "1 tsp",
            "1 tblsp"
        ]
    },
    {
        "id": 169,
        "name": "Brandy Flip",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/6ty09d1504366461.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the brandy, egg, sugar, and cream. Shake well. Strain into a sour glass and garnish with the nutmeg.",
        "ingredients": [
            "Brandy",
            "Egg",
            "Sugar",
            "Cream",
            "Nutmeg"
        ],
        "amounts": [
            "2 oz",
            "1 whole",
            "1 tsp superfine",
            "1/2 oz",
            "1/8 tsp grated"
        ]
    },
    {
        "id": 270,
        "name": "Gin Squirt",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xrbhz61504883702.jpg",
        "glass": "Highball glass",
        "instructions": "Stir gin, grenadine, and powdered sugar with ice and strain into a highball glass over ice cubes. Fill with carbonated water and stir. Decorate with the pineapple chunks and the strawberries and serve.",
        "ingredients": [
            "Gin",
            "Grenadine",
            "Sugar",
            "Juice - Pineapple",
            "Strawberries",
            "Water - Soda"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 tsp",
            "1 tblsp",
            "3 chunks"
        ]
    },
    {
        "id": 170,
        "name": "Brandy Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tu0mts1504366540.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake brandy, juice of lemon, and powdered sugar with ice and strain into a whiskey sour glass. Decorate with the lemon slice, top with the cherry, and serve.",
        "ingredients": [
            "Brandy",
            "Lemon",
            "Sugar",
            "Lemon",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1/2 tsp",
            "1/2 slice"
        ]
    },
    {
        "id": 265,
        "name": "Gin Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xhl8q31504351772.jpg",
        "glass": "Highball glass",
        "instructions": "Shake all ingredients with ice cubes, except soda water. Pour into glass. Top with soda water.",
        "ingredients": [
            "Gin",
            "Lemon",
            "Sugar",
            "Water - Soda"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1 tsp"
        ]
    },
    {
        "id": 267,
        "name": "Gin Sling",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/h8wmm41504883440.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Dissolve powdered sugar in mixture of water and juice of lemon. Add gin. Pour into an old-fashioned glass over ice cubes and stir. Add the twist orange peel and serve.",
        "ingredients": [
            "Gin",
            "Lemon",
            "Sugar",
            "Water",
            "Orange peel"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1 tsp",
            "1 tsp",
            "twist"
        ]
    },
    {
        "id": 434,
        "name": "Royal Gin Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/pe1x1c1504735672.jpg",
        "glass": "Highball glass",
        "instructions": "Shake all ingredients (except carbonated water) with ice and strain into a highball glass over two ice cubes. Fill with carbonated water, stir, and serve.",
        "ingredients": [
            "Gin",
            "Lemon",
            "Sugar",
            "Egg",
            "Water - Soda"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1 tsp",
            "1 whole"
        ]
    },
    {
        "id": 494,
        "name": "Tequila Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ek0mlq1504820601.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake tequila, juice of lemon, and powdered sugar with ice and strain into a whiskey sour glass. Add the half-slice of lemon, top with the cherry, and serve.",
        "ingredients": [
            "Tequila",
            "Lemon",
            "Sugar",
            "Lemon",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1 tsp",
            "1/2 slice"
        ]
    },
    {
        "id": 159,
        "name": "Boston Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/kxlgbi1504366100.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake juice of lemon, powdered sugar, blended whiskey, and egg white with cracked ice and strain into a whiskey sour glass. Add the slice of lemon, top with the cherry, and serve.",
        "ingredients": [
            "Whiskey",
            "Lemon",
            "Sugar",
            "Egg white",
            "Lemon",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1 tsp",
            "1 slice"
        ]
    },
    {
        "id": 316,
        "name": "Japanese Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/37vzv11504884831.jpg",
        "glass": "Highball glass",
        "instructions": "Shake all ingredients (except carbonated water) with ice and strain into a highball glass over two ice cubes. Fill with carbonated water, stir, and serve.",
        "ingredients": [
            "Whiskey",
            "Lemon",
            "Sugar",
            "Port",
            "Egg white",
            "Water - Soda"
        ],
        "amounts": [
            "1 1/2 oz",
            "Juice of 1/2",
            "1 tsp",
            "1 tblsp"
        ]
    },
    {
        "id": 388,
        "name": "New York Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/61wgch1504882795.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake blended whiskey, juice of lemon, and powdered sugar with ice and strain into a whiskey sour glass. Float partsaret on top. Decorate with the half-slice of lemon and the cherry and serve.",
        "ingredients": [
            "Whiskey",
            "Lemon",
            "Sugar",
            "Red wine",
            "Lemon",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1 tsp",
            "(partsaret)"
        ]
    },
    {
        "id": 525,
        "name": "Whiskey Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/o56h041504352725.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Shake with ice. Strain into chilled glass, garnish and serve. If served 'On the rocks', strain ingredients into old-fashioned glass filled with ice.",
        "ingredients": [
            "Whiskey",
            "Lemon",
            "Sugar",
            "Cherry",
            "Lemon"
        ],
        "amounts": [
            "2 oz",
            "Juice of 1/2",
            "1/2 tsp",
            "1/2 slice"
        ]
    },
    {
        "id": 161,
        "name": "Bourbon Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/dms3io1504366318.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the bourbon, lemon juice, and sugar. Shake well. Strain into a whiskey sour glass, garnish with the orange slice and cherry.",
        "ingredients": [
            "Bourbon",
            "Juice - Lemon",
            "Sugar",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1/2 tsp superfine"
        ]
    },
    {
        "id": 321,
        "name": "John Collins",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/u5yaxl1504350270.jpg",
        "glass": "Collins glass",
        "instructions": "Pour all ingredients directly into highball glass filled with ice. Stir gently. Garnish. Add a dash of Angostura bitters.",
        "ingredients": [
            "Bourbon",
            "Juice - Lemon",
            "Sugar",
            "partsub soda",
            "Cherry",
            "Orange"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1 tsp superfine",
            "3 oz"
        ]
    },
    {
        "id": 264,
        "name": "Gin Daisy",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qwxysv1478819943.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the wine, lemon juice, sugar, and grenadine. Shake well. Pour into an old-fashioned glass and garnish with the cherry and the orange slice.",
        "ingredients": [
            "Gin",
            "Juice - Lemon",
            "Sugar",
            "Grenadine",
            "Cherry",
            "Orange"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1/2 tsp superfine",
            "1/2 tsp"
        ]
    },
    {
        "id": 269,
        "name": "Gin Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/mt7l7m1504883523.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the gin, lemon juice, and sugar. Shake well. Strain into a sour glass and garnish with the orange slice and the cherry.",
        "ingredients": [
            "Gin",
            "Juice - Lemon",
            "Sugar",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1/2 tsp superfine"
        ]
    },
    {
        "id": 505,
        "name": "Tom Collins",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qystvv1439907682.jpg",
        "glass": "Collins glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the gin, lemon juice, and sugar. Shake well. Strain into a collins glass alomst filled with ice cubes. Add the partsub soda. Stir and garnish with the cherry and the orange slice.",
        "ingredients": [
            "Gin",
            "Juice - Lemon",
            "Sugar",
            "partsub soda",
            "Cherry",
            "Orange"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1 tsp superfine",
            "3 oz"
        ]
    },
    {
        "id": 443,
        "name": "Rum Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/bylfi21504886323.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the rum, lemon juice, and sugar. Shake well. Strain into a sour glass and garnish with the orange slice and the cherry.",
        "ingredients": [
            "Rum - Light",
            "Juice - Lemon",
            "Sugar",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1/2 tsp superfine"
        ]
    },
    {
        "id": 408,
        "name": "Pisco Sour",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/tsssur1439907622.jpg",
        "glass": "Cocktail glass",
        "instructions": "Vigorously shake and strain contents in a cocktail shaker with ice cubes, then pour into glass and garnish with bitters.[1]",
        "ingredients": [
            "Pisco",
            "Juice - Lemon",
            "Sugar",
            "Ice"
        ],
        "amounts": [
            "2 oz",
            "1 oz",
            "1-2 tblsp"
        ]
    },
    {
        "id": 338,
        "name": "Lady Love Fizz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/20d63k1504885263.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients (except carbonated water) with ice and strain into a cocktail glass over two ice cubes. Fill with carbonated water, stir, and serve.",
        "ingredients": [
            "Gin",
            "Cream",
            "Sugar",
            "Lemon",
            "Egg white",
            "Water - Soda"
        ],
        "amounts": [
            "2 oz",
            "2 tsp",
            "1 tsp",
            "Juice of 1/2"
        ]
    },
    {
        "id": 414,
        "name": "Port Wine Flip",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vrprxu1441553844.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake all ingredients (except nutmeg) with ice and strain into a whiskey sour glass. Sprinkle nutmeg on top and serve.",
        "ingredients": [
            "Port",
            "Cream",
            "Sugar",
            "Egg",
            "Nutmeg"
        ],
        "amounts": [
            "1 1/2 oz",
            "2 tsp",
            "1 tsp",
            "1 whole"
        ]
    },
    {
        "id": 463,
        "name": "Sherry Flip",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qrryvq1478820428.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake all ingredients (except nutmeg) with ice and strain into a whiskey sour glass. Sprinkle nutmeg on top and serve.",
        "ingredients": [
            "Sherry",
            "Cream",
            "Sugar",
            "Egg",
            "Nutmeg"
        ],
        "amounts": [
            "1 1/2 oz cream",
            "2 tsp",
            "1 tsp",
            "1 whole"
        ]
    },
    {
        "id": 376,
        "name": "Mojito",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/rxtqps1478251029.jpg",
        "glass": "Highball glass",
        "instructions": "Muddle mint leaves with sugar and lime juice. Add a splash of soda water and fill the glass with cracked ice. Pour the rum and top with soda water. Garnish and serve with straw.",
        "ingredients": [
            "Rum - Light",
            "Lime",
            "Sugar",
            "Mint",
            "Water - Soda"
        ],
        "amounts": [
            "2-3 oz",
            "Juice of 1",
            "2 tsp",
            "2-4"
        ]
    },
    {
        "id": 214,
        "name": "Daiquiri",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/usuuur1439906797.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into shaker with ice cubes. Shake well. Strain in chilled cocktail glass.",
        "ingredients": [
            "Rum - Light",
            "Lime",
            "Sugar"
        ],
        "amounts": [
            "1 1/2 oz",
            "Juice of 1/2",
            "1 tsp"
        ]
    },
    {
        "id": 454,
        "name": "Scotch Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/0dnb6k1504890436.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake scotch, juice of lime, and powdered sugar with ice and strain into a whiskey sour glass. Decorate with 1/2 slice lemon, top with the cherry, and serve.",
        "ingredients": [
            "Scotch",
            "Lime",
            "Sugar",
            "Lemon",
            "Cherry"
        ],
        "amounts": [
            "1 1/2 oz",
            "Juice of 1/2",
            "1/2 tsp",
            "1/2 slice"
        ]
    },
    {
        "id": 438,
        "name": "Rum Milk Punch",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/w64lqm1504888810.jpg",
        "glass": "Collins glass",
        "instructions": "Shake all ingredients (except nutmeg) with ice and strain into a collins glass. Sprinkle nutmeg on top and serve.",
        "ingredients": [
            "Rum - Light",
            "Milk",
            "Sugar",
            "Nutmeg"
        ],
        "amounts": [
            "2 oz",
            "1 cup",
            "1 tsp"
        ]
    },
    {
        "id": 337,
        "name": "Kurant Tea",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/xrsrpr1441247464.jpg",
        "glass": "Champagne flute",
        "instructions": "Pour Absolut Kurant into a comfortably big tea-cup. Add the not too hot(!) apple tea and, if you like, some sugar. Enjoy!",
        "ingredients": [
            "Vodka - Berry",
            "Tea",
            "Sugar"
        ],
        "amounts": [
            "4 parts",
            "Turkish apple",
            "(if needed)"
        ]
    },
    {
        "id": 203,
        "name": "Coffee Liqueur",
        "type": "Homemade Liqueur",
        "image": "http://www.thecocktaildb.com/images/media/drink/ryvtsu1441253851.jpg",
        "glass": "Collins Glass",
        "instructions": "Combine coffee, sugar and water. Simmer 1 hour and let cool. Add vanilla and vodka. Age in sealed jar 2 to 3 weeks.",
        "ingredients": [
            "Coffee",
            "Vanilla extract",
            "Sugar",
            "Vodka",
            "Water"
        ],
        "amounts": [
            "10 tblsp instant",
            "4 tblsp",
            "2 1/2 cups",
            "1 qt",
            "2 1/2 cups"
        ]
    },
    {
        "id": 200,
        "name": "partsassic Old-Fashioned",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/anhof61504366173.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In an old-fashioned glass, muddle the bitters and water into the sugar cube, using the back of a teaspoon. Almost fill the glass with ice cubes and add the bourbon. Garnish with the orange slice and the cherry. Serve with a swizzle stick.",
        "ingredients": [
            "Bitters",
            "Water",
            "Sugar",
            "Bourbon",
            "Orange",
            "Cherry"
        ],
        "amounts": [
            "3 dashes",
            "1 tsp",
            "3 oz"
        ]
    },
    {
        "id": 272,
        "name": "Gin Toddy",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/l9gi5h1504820724.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Mix powdered sugar and water in an old-fashioned glass. Add gin and one ice cube. Stir, add the twist lemon peel, and serve.",
        "ingredients": [
            "Gin",
            "Water",
            "Sugar",
            "Peel - Lemon"
        ],
        "amounts": [
            "2 oz",
            "2 tsp",
            "1/2 tsp",
            "1 twist"
        ]
    },
    {
        "id": 104,
        "name": "Arizona Antifreeze",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/dbtylp1493067262.jpg",
        "glass": "Shot glass",
        "instructions": "Pour all ingredients into shot glass and slam !!!!",
        "ingredients": [
            "Vodka",
            "Liqueur - Melon",
            "Sweet and sour"
        ],
        "amounts": [
            "1/3 oz",
            "1/3 oz",
            "1/3 oz"
        ]
    },
    {
        "id": 480,
        "name": "Stone Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vruvtp1472719895.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Shake all ingredients with ice, strain into a chilled whiskey sour glass, and serve.",
        "ingredients": [
            "Brandy",
            "Juice - Orange",
            "Sweet and sour"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 260,
        "name": "Gentleman's partsub",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/ezvy1c1504883335.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In an old-fashioned glass almost filled with ice cubes, combine all of the ingredients. Stir well.",
        "ingredients": [
            "Gin",
            "Brandy",
            "Sweet Vermouth",
            "partsub soda"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 386,
        "name": "Negroni",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tutwwv1439907127.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Stir into glass over ice, garnish and serve.",
        "ingredients": [
            "Gin",
            "Campari",
            "Sweet Vermouth"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 234,
        "name": "English Highball",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/dhvr7d1504519752.jpg",
        "glass": "Highball glass",
        "instructions": "Pour brandy, gin, and sweet vermouth into a highball glass over ice cubes. Fill with carbonated water. Add the twist lemon peel, stir, and serve. (Ginger ale may be substituted for carbonated water, if preferred.)",
        "ingredients": [
            "Brandy",
            "Gin",
            "Sweet Vermouth",
            "Water - Soda",
            "Peel - Lemon"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 237,
        "name": "Fahrenheit 5000",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/tysssx1473344692.jpg",
        "glass": "Shot glass",
        "instructions": "Cover bottom of shot glass with Tabasco Sauce and then fill with half Firewater and half Absolut Peppar.",
        "ingredients": [
            "Vodka",
            "Vodka - Pepper",
            "Tabasco"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1 dash"
        ]
    },
    {
        "id": 81,
        "name": "Amaretto Stone Sour #3",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/wutxqr1472720012.jpg",
        "glass": "Highball glass",
        "instructions": "Shake sour mix, tequila and amaretto with ice. Strain into highball glass. Add a splash of OJ. Garnish with orange slice and a cherry.",
        "ingredients": [
            "Sweet and Sour",
            "Amaretto",
            "Tequila",
            "Juice - Orange"
        ],
        "amounts": [
            "2 oz",
            "2 oz",
            "2 oz",
            "Add splash"
        ]
    },
    {
        "id": 8,
        "name": "3-Mile Long Island Iced Tea",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rrtssw1472668972.jpg",
        "glass": "Collins Glass",
        "instructions": "Fill 14oz glass with ice and alcohol. Fill 2/3 glass with cola and remainder with sweet & sour. Top with dash of bitters and lemon wedge.",
        "ingredients": [
            "Gin",
            "Rum - Light",
            "Tequila",
            "Triple Sec",
            "Vodka",
            "Coke",
            "Sweet and sour",
            "Bitters",
            "Lemon"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1-2 dash",
            "1 wedge"
        ]
    },
    {
        "id": 224,
        "name": "Downshift",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/y36z8c1503563911.jpg",
        "glass": "Hurricane glass",
        "instructions": "Start with the Sprite. Next comes the tequila. After that, add the Minute Maid Fruit Punch, then float the 151. Rocks optional.",
        "ingredients": [
            "Fruit Punch",
            "Sprite",
            "Tequila",
            "Rum - Strong"
        ],
        "amounts": [
            "2 part",
            "1 part",
            "2 shots",
            "Float"
        ]
    },
    {
        "id": 425,
        "name": "Radioactive Long Island Iced Tea",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rdvqmh1503563512.jpg",
        "glass": "Collins Glass",
        "instructions": "Pour all ingredients over ice in a very tall glass. Sip cautiously.",
        "ingredients": [
            "Rum",
            "Vodka",
            "Tequila",
            "Gin",
            "Triple Sec",
            "Liqueur - Raspberry",
            "Liqueur - Melon",
            "Rum - Coconunt"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 45,
        "name": "Adam Bomb",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tpxurs1454513016.jpg",
        "glass": "Margarita/Coupette glass",
        "instructions": "Add ice to blender (or to glass if prefer on the rocks) then fruit, and fruite juice depending on personal prefference then add the Rum, Vodka, Tequila, and triple sec. blend till smooth, rim glass with sugar or salt and pour mixture in. garnish with lemon or lime slice.",
        "ingredients": [
            "Rum",
            "Vodka",
            "Tequila",
            "Triple Sec",
            "Fruit",
            "Ice",
            "Salt",
            "Fruit juice"
        ],
        "amounts": [
            "1 part",
            "1 part",
            "1 part",
            "1/2 part",
            "1-3 pint"
        ]
    },
    {
        "id": 399,
        "name": "Orgasm",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vr6kle1504886114.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a chilled cocktail glass, and serve.",
        "ingredients": [
            "Creme de Cacao",
            "Amaretto",
            "Triple Sec",
            "Vodka",
            "Cream"
        ],
        "amounts": [
            "1/2 oz white",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1 oz"
        ]
    },
    {
        "id": 98,
        "name": "Apricot Lady",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/146f251504389814.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In a shaker half-filled with ice cubes, combine the rum, apricot brandy, triple sec, lemon juice, and egg white. Shake well. Strain into an old-fashioned glass almost filled with ice cubes. Garnish with the orange slice.",
        "ingredients": [
            "Rum - Light",
            "Brandy - Apricot",
            "Triple Sec",
            "Juice - Lemon",
            "Egg white",
            "Orange"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz",
            "1 tsp",
            "1/2 oz"
        ]
    },
    {
        "id": 158,
        "name": "Boston Sidecar",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qzs5d11504365962.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Rum - Light",
            "Brandy",
            "Triple Sec",
            "Lime"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "3/4 oz",
            "Juice of 1/2"
        ]
    },
    {
        "id": 453,
        "name": "Scotch Cobbler",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/1q7coh1504736227.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour scotch, brandy, and curacao over ice in an old-fashioned glass. Add the orange slice, top with the mint sprig, and serve.",
        "ingredients": [
            "Scotch",
            "Brandy",
            "Triple Sec",
            "Orange",
            "Mint"
        ],
        "amounts": [
            "2 oz",
            "4 dashes",
            "4 dashes",
            "1 slice"
        ]
    },
    {
        "id": 132,
        "name": "Belgian Blue",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/rttsxw1441245419.jpg",
        "glass": "Highball glass",
        "instructions": "Just pour all ingredients in the glass and stir...",
        "ingredients": [
            "Vodka",
            "Coconut liqueur",
            "Triple Sec",
            "Sprite"
        ],
        "amounts": [
            "2 parts",
            "1 parts",
            "1 parts",
            "Fill with"
        ]
    },
    {
        "id": 363,
        "name": "Martinez Cocktail",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/wwxwvr1439906452.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients (except cherry) with ice and strain into a cocktail glass. Top with the cherry and serve.",
        "ingredients": [
            "Gin",
            "Dry Vermouth",
            "Triple Sec",
            "Bitters",
            "Cherry"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1/4 tsp",
            "1 dash"
        ]
    },
    {
        "id": 532,
        "name": "Yellow Bird",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/2t9r6w1504374811.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake and strain into a chilled cocktail glass",
        "ingredients": [
            "Rum - Light",
            "Galliano",
            "Triple Sec",
            "Juice - Lime"
        ],
        "amounts": [
            "3 parts",
            "1.5 parts",
            "1.5 parts",
            "1.5 parts"
        ]
    },
    {
        "id": 137,
        "name": "Between The Sheets",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/of1rj41504348346.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour all ingredients into shaker with ice cubes, shake, strain into chilled cocktail glass.",
        "ingredients": [
            "Brandy",
            "Rum - Light",
            "Triple Sec",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 206,
        "name": "Cosmopolitan",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/kpsajh1504368362.jpg",
        "glass": "Cocktail glass",
        "instructions": "Add all ingredients into cocktail shaker filled with ice. Shake well and double strain into large cocktail glass. Garnish with lime wheel.",
        "ingredients": [
            "Vodka - Citrus",
            "Juice - Lime",
            "Triple Sec",
            "Juice - Cranberry"
        ],
        "amounts": [
            "1 1/4 oz",
            "1/4 oz",
            "1/4 oz",
            "1/4 cup"
        ]
    },
    {
        "id": 178,
        "name": "Cafe Savoy",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/vqwptt1441247711.jpg",
        "glass": "Coffee mug",
        "instructions": "Fill mug almost to top with coffee.Add milk, triple sec and brandy. Stir.",
        "ingredients": [
            "Coffee",
            "Milk",
            "Triple Sec",
            "Brandy"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 40,
        "name": "Absolutly Screwed Up",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/yvxrwv1472669728.jpg",
        "glass": "Collins glass",
        "instructions": "Shake it up it tasts better that way, but you can stir it if you want. 6 of those and you will be wasted for the rest of the night.",
        "ingredients": [
            "Vodka - Citrus",
            "Juice - Orange",
            "Triple Sec",
            "Ginger ale"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "1 shot",
            "Fill to top"
        ]
    },
    {
        "id": 358,
        "name": "Mai Tai",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/twyrrp1439907470.jpg",
        "glass": "Collins glass",
        "instructions": "Shake all ingredients with ice. Strain into glass. Garnish and serve with straw.",
        "ingredients": [
            "Rum - Light",
            "Orgeat syrup",
            "Triple Sec",
            "Sweet and sour",
            "Cherry"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "1/2 oz",
            "1 1/2 oz"
        ]
    },
    {
        "id": 279,
        "name": "Grand Blue",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vsrsqu1472761749.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Serve in an old fashioned glass.",
        "ingredients": [
            "Rum - Cocounut",
            "Peach schnapps",
            "Triple Sec",
            "Sweet and sour"
        ],
        "amounts": [
            "1 1/2 parts",
            "1 1/2 parts",
            "1 1/2 parts",
            "3 parts"
        ]
    },
    {
        "id": 239,
        "name": "Flaming Lamborghini",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/yywpss1461866587.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour the Sambuca and Kahlua into the Cocktail Glass and give the drinker a straw. Pour the Baileys and Blue Curacao into two sepsrate shot glasses either side of the cocktail glass. Set light the concotion in the cocktail glass and start to drink through the straw (this drink should be drunk in one) , as the bottom of the glass is reached put out the fire by pouring the Baileys and Blue Curacao into the cocktail glass and keep drinking till it's all gone!!",
        "ingredients": [
            "Kahlua",
            "Sambuca",
            "Triple Sec",
            "Bailey's irish cream"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 120,
        "name": "B-53",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/rwqxrv1461866023.jpg",
        "glass": "Collins Glass",
        "instructions": "Layer the Kahlua, Sambucca and Grand Marnier into a shot glas in that order. Better than B-52",
        "ingredients": [
            "Kahlua",
            "Sambuca",
            "Triple Sec"
        ],
        "amounts": [
            "1/3 shot",
            "1/3 shot",
            "1/3 shot"
        ]
    },
    {
        "id": 483,
        "name": "Strawberry Margarita",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tqyrpw1439905311.jpg",
        "glass": "Cocktail glass",
        "instructions": "Rub rim of cocktail glass with lemon juice and dip rim in salt. Shake schnapps, tequila, triple sec, lemon juice, and strawberries with ice, strain into the salt-rimmed glass, and serve.",
        "ingredients": [
            "Liqueur - Strawberry",
            "Tequila",
            "Triple Sec",
            "Juice - Lemon",
            "Strawberries",
            "Salt"
        ],
        "amounts": [
            "1/2 oz",
            "1 oz",
            "1/2 oz",
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 152,
        "name": "Bluebird",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vxypsq1441209971.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with crushed ice, combine the gin, triple sec, Curacao, and bitters. Stir well. Strain into a cocktail glass and garnish with the lemon twist and the cherry.",
        "ingredients": [
            "Gin",
            "Triple Sec",
            "Triple Sec",
            "Bitters",
            "Cherry",
            "Peel - Lemon"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "2 dashes",
            "1 twist"
        ]
    },
    {
        "id": 112,
        "name": "Atomic Lokade",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/n3zfrh1493067412.jpg",
        "glass": "Collins Glass",
        "instructions": "In a shaker, place lemonade, vodka, blue Curacao, and triple sec together. Shake with ice and strain into glass. Add sugar to taste",
        "ingredients": [
            "Lemonade",
            "Vodka",
            "Triple Sec",
            "Triple Sec",
            "Sugar",
            "Ice"
        ],
        "amounts": [
            "5 oz",
            "1 oz",
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 261,
        "name": "Gideon's Green Dinosaur",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/p5r0tr1503564636.jpg",
        "glass": "Collins glass",
        "instructions": "Add all ingredients in collins glass with ice and stir.",
        "ingredients": [
            "Rum - Dark",
            "Vodka",
            "Triple Sec",
            "Tequila",
            "Melon liqueur",
            "Mountain Dew"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "Fill with"
        ]
    },
    {
        "id": 121,
        "name": "Baby Eskimo",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/wywrtw1472720227.jpg",
        "glass": "Collins Glass",
        "instructions": "Leave ice-cream out for about 10 minutes. Add ingredients in order, stir with chopstick (butter knife or spoon works too). Consume immediately and often. Nice and light, great for following a heavy drink.",
        "ingredients": [
            "Kahlua",
            "Milk",
            "Vanilla ice-cream"
        ],
        "amounts": [
            "2 oz",
            "8 oz",
            "2 scoops"
        ]
    },
    {
        "id": 307,
        "name": "Irish Curdling Cow",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/yrhutv1503563730.jpg",
        "glass": "Highball glass",
        "instructions": "Pour Irish Cream, Vodka, and Bourbon in a glass. Add some ice and mix in the orange juice.",
        "ingredients": [
            "Bailey's irish cream",
            "Bourbon",
            "Vodka",
            "Juice - Orange"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "3/4 oz",
            "2-3 oz"
        ]
    },
    {
        "id": 99,
        "name": "Apricot punch",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tuxxtp1472668667.jpg",
        "glass": "Punch bowl",
        "instructions": "Pour all ingrediants into a large punch bowl. Add ice and 4 oranges that are peeled and divided.",
        "ingredients": [
            "Brandy",
            "Champagne",
            "Vodka",
            "Sprite",
            "Juice - Orange"
        ],
        "amounts": [
            "1 qt",
            "4 fifth",
            "1 fifth",
            "4 L",
            "1/2 gal"
        ]
    },
    {
        "id": 141,
        "name": "Black Forest Shake",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/xxtxsu1472720505.jpg",
        "glass": "Collins Glass",
        "instructions": "In a blender put ice cubes, chocolate syrup, cherry brandy, vodka, and milk. Blend very well.",
        "ingredients": [
            "Chocolate syrup",
            "Brandy",
            "Vodka",
            "Milk"
        ],
        "amounts": []
    },
    {
        "id": 4,
        "name": "155 Belmont",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/yqvvqs1475667388.jpg",
        "glass": "White wine glass",
        "instructions": "Blend with ice. Serve in a wine glass. Garnish with carrot.",
        "ingredients": [
            "Rum - Dark",
            "Rum - Light",
            "Vodka",
            "Juice - Orange"
        ],
        "amounts": [
            "1 shot",
            "2 shots",
            "1 shot",
            "1 shot"
        ]
    },
    {
        "id": 406,
        "name": "Pink Panty Pulldowns",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/squsuy1468926657.jpg",
        "glass": "Collins Glass",
        "instructions": "Shake well",
        "ingredients": [
            "Sprite",
            "Pink lemonade",
            "Vodka"
        ],
        "amounts": [
            "1 L",
            "2 cups",
            "2 cups"
        ]
    },
    {
        "id": 396,
        "name": "Orange Whip",
        "type": "Other/Unknown",
        "image": "http://www.thecocktaildb.com/images/media/drink/ttyrxr1454514759.jpg",
        "glass": "Collins Glass",
        "instructions": "Pour ingredients over ice and stir.",
        "ingredients": [
            "Juice - Orange",
            "Rum",
            "Vodka",
            "Cream",
            "Ice"
        ],
        "amounts": [
            "4 oz",
            "1 oz",
            "1 oz",
            "1 package",
            "Over"
        ]
    },
    {
        "id": 245,
        "name": "Freddy Kruger",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/tuppuq1461866798.jpg",
        "glass": "Shot glass",
        "instructions": "make it an ample size shot!!",
        "ingredients": [
            "Jägermeister",
            "Sambuca",
            "Vodka"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 24,
        "name": "A.D.M. (After Dinner Mint)",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/ruxuvp1472669600.jpg",
        "glass": "Irish coffee cup",
        "instructions": "shake vigorously",
        "ingredients": [
            "White Creme de Menthe",
            "Southern Comfort",
            "Vodka",
            "Hot chocolate"
        ],
        "amounts": [
            "1/2 oz",
            "3/4 oz",
            "1/2 oz",
            "Fill with"
        ]
    },
    {
        "id": 190,
        "name": "Cherry Electric Lemonade",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/tquyyt1451299548.jpg",
        "glass": "Pint glass",
        "instructions": "Now stir vigorously and then pour over a large cup of ice. Now drink it with a straw and stir occasionally.",
        "ingredients": [
            "Gin",
            "Tequila",
            "Vodka",
            "White rum",
            "Triple Sec",
            "Cherry Grenadine",
            "Sweet and sour",
            "partsub soda"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "1 oz",
            "3 oz"
        ]
    },
    {
        "id": 151,
        "name": "Blue Mountain",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vsxssp1441209853.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In a shaker half-filled with ice cubes, combine all of the ingredients. Shake well. Strain into an old-fashioned glass alomst filled with ice cubes.",
        "ingredients": [
            "Rum",
            "Tia maria",
            "Vodka",
            "Juice - Orange",
            "Juice - Lemon"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1/2 oz",
            "1 oz",
            "1 tsp"
        ]
    },
    {
        "id": 461,
        "name": "Shark Attack",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/uv96zr1504793256.jpg",
        "glass": "Pitcher",
        "instructions": "Mix lemonade and water according to instructions on back of can. If the instructions say to add 4 1/3 cans of water do so. Mix into pitcher. Add 1 1/2 cup of Vodka (Absolut). Mix well. Pour into glass of crushed ice. Excellent!",
        "ingredients": [
            "Lemonade",
            "Water",
            "Vodka"
        ],
        "amounts": [
            "1 can",
            "3 cans",
            "1 1/2 cup"
        ]
    },
    {
        "id": 315,
        "name": "Jamaican Coffee",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/xqptps1441247257.jpg",
        "glass": "Champagne flute",
        "instructions": "Stir the rum, coffee and water together. Top with the whipped cream. Sprinkle with a pinch of well ground coffee and drink with a straw.",
        "ingredients": [
            "Rum",
            "Coffee",
            "Water",
            "Whipped cream"
        ],
        "amounts": [
            "1/6 glass",
            "1/6 glass strong black",
            "1/2 glass cold"
        ]
    },
    {
        "id": 317,
        "name": "Jello shots",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/l0smzo1504884904.jpg",
        "glass": "Shot glass",
        "instructions": "Boil 3 cups of water then add jello. Mix jello and water until jello is completely disolved. Add the two cups of vodka and mix together. Pour mixture into plastic shot glasses and chill until firm. Then, eat away...",
        "ingredients": [
            "Vodka",
            "Jello",
            "Water"
        ],
        "amounts": [
            "2 cups",
            "3 packages",
            "3 cups"
        ]
    },
    {
        "id": 46,
        "name": "Adam Sunrise",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vtuyvu1472812112.jpg",
        "glass": "Collins Glass",
        "instructions": "Fill blender up with ice. Fill half with Bartons Vodka. Put 10 tsp of sugar, add 1/2 can lemonade concentrate, fill to top with water. Blend for 60 seconds.",
        "ingredients": [
            "Vodka",
            "Lemonade",
            "Water",
            "Sugar"
        ],
        "amounts": [
            "1/2",
            "1/2 can",
            "1/2",
            "10 tsp"
        ]
    },
    {
        "id": 489,
        "name": "Sweet Sangria",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/uqqvsp1468924228.jpg",
        "glass": "Pitcher",
        "instructions": "Dissolve the sugar in hot water and cool. Peel the citrus fruits and break into wedges. Mix the wine, sugar syrup, fruit, and Fresca in a pitcher and put in the fridge for a few hours. Serve in tall glasses with a straw.",
        "ingredients": [
            "Wine - Red",
            "Sugar",
            "Water",
            "Apple",
            "Orange",
            "Lime",
            "Lemon",
            "Fresca"
        ],
        "amounts": [
            "2 bottles",
            "1 cup",
            "2 cups hot",
            "1 cup",
            "wedges",
            "wedges"
        ]
    },
    {
        "id": 478,
        "name": "Spritz",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/j9evx11504373665.jpg",
        "glass": "Old-Fashioned glass",
        "instructions": "Build into glass over ice, garnish and serve.",
        "ingredients": [
            "Prosecco",
            "Campari",
            "Water - Soda"
        ],
        "amounts": [
            "6 parts",
            "4 parts",
            "splash"
        ]
    },
    {
        "id": 514,
        "name": "Vermouth Cassis",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tswpxx1441554674.jpg",
        "glass": "Highball glass",
        "instructions": "Stir vermouth and creme de cassis in a highball glass with ice cubes. Fill with carbonated water, stir again, and serve.",
        "ingredients": [
            "Dry Vermouth",
            "Creme de Cassis",
            "Water - Soda"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 47,
        "name": "Addington",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/ib0b7g1504818925.jpg",
        "glass": "Cocktail glass",
        "instructions": "Mix both the vermouth's in a shaker and strain into a cold glass. Top up with a squirt of Soda Water.",
        "ingredients": [
            "Sweet Vermouth",
            "Dry Vermouth",
            "Water - Soda"
        ],
        "amounts": [
            "2 shots",
            "1 shot",
            "Top up with"
        ]
    },
    {
        "id": 182,
        "name": "California Root Beer",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/rsxuyr1472719526.jpg",
        "glass": "Highball glass",
        "instructions": "Put Kahlua and Galliano in highball glass fill with soda",
        "ingredients": [
            "Kahlua",
            "Galliano",
            "Water - Soda"
        ],
        "amounts": [
            "3/4 oz",
            "3/4 oz",
            "Fill with"
        ]
    },
    {
        "id": 114,
        "name": "Autodafé",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/7dkf0i1487602928.jpg",
        "glass": "Highball glass",
        "instructions": "Mix and fill up with soda water. Drunk by finns on a sunny day any time of the year and day.",
        "ingredients": [
            "Vodka",
            "Juice - Lime",
            "Water - Soda"
        ],
        "amounts": [
            "4 parts",
            "1 dash"
        ]
    },
    {
        "id": 540,
        "name": "Zipperhead",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/r2qzhu1485620235.jpg",
        "glass": "Whiskey sour glass",
        "instructions": "Fill glass with rocks, add straw before putting in liquor. Then add the ingredients in order, trying to keep layered as much as possible (i.e. Chambord on bottom, then Vodka, Then soda on top).",
        "ingredients": [
            "Chamboard",
            "Vodka",
            "Water - Soda"
        ],
        "amounts": [
            "1 shot",
            "1 shot",
            "Fill with"
        ]
    },
    {
        "id": 28,
        "name": "AT&T",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rhhwmp1493067619.jpg",
        "glass": "Highball Glass",
        "instructions": "Pour Vodka and Gin over ice, add Tonic and Stir",
        "ingredients": [
            "Vodka",
            "Gin",
            "Water - Tonic"
        ],
        "amounts": [
            "1 oz",
            "1 oz",
            "4 oz"
        ]
    },
    {
        "id": 85,
        "name": "Amaretto Tea",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/b7qzo21493070167.jpg",
        "glass": "Pousse cafe glass",
        "instructions": "Pour hot tea into a pousse-cafe glass, using a spoon in glass to prevent cracking. Add amaretto, but do not stir. Top with chilled whipped cream and serve.",
        "ingredients": [
            "Tea",
            "Amaretto",
            "Whipped cream"
        ],
        "amounts": [
            "6 oz hot",
            "2 oz",
            "Chilled"
        ]
    },
    {
        "id": 545,
        "name": "Zorro",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/kvvd4z1485621283.jpg",
        "glass": "Coffee Mug",
        "instructions": "add all and pour black coffee and add whipped cream on top.",
        "ingredients": [
            "Sambuca",
            "Bailey's irish cream",
            "White Creme de Menthe"
        ],
        "amounts": [
            "2 parts",
            "2 parts",
            "2 parts"
        ]
    },
    {
        "id": 180,
        "name": "Caipirissima",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yd47111503565515.jpg",
        "glass": "Collins Glass",
        "instructions": "Same as Caipirinha but instead of cachaca you add WHITE RUM. It's great!!!!!!!!",
        "ingredients": [
            "Lime",
            "Sugar",
            "White rum",
            "Ice"
        ],
        "amounts": [
            "2 tblsp",
            "2-3 oz",
            "crushed"
        ]
    },
    {
        "id": 201,
        "name": "partsove Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qxvtst1461867579.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Sweet Vermouth",
            "Gin",
            "Wine"
        ],
        "amounts": [
            "1 oz",
            "1/2 oz",
            "1/2 oz Muscatel"
        ]
    },
    {
        "id": 61,
        "name": "Alaska Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wsyryt1483387720.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir all ingredients with ice, strain contents into a cocktail glass. Drop in a twist lemon and serve.",
        "ingredients": [
            "Bitters - Orange",
            "Gin",
            "Yellow Chartreuse",
            "Peel - Lemon"
        ],
        "amounts": [
            "2 dashes",
            "1 1/2 oz",
            "3/4 oz",
            "twist"
        ]
    },
    {
        "id": 319,
        "name": "Jewel Of The Nile",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/hx4nrb1504884947.jpg",
        "glass": "Cocktail glass",
        "instructions": "In a mixing glass half-filled with ice cubes, combine all of the ingredients. Stir well. Strain into a cocktail glass.",
        "ingredients": [
            "Gin",
            "Green Chartreuse",
            "Yellow Chartreuse"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 248,
        "name": "French Connection",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/zaqa381504368758.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour all ingredients directly into old fashioned glass filled with ice cubes. Stir gently.",
        "ingredients": [
            "Cognac",
            "Amaretto"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 312,
        "name": "Jackhammer",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/9von5j1504388896.jpg",
        "glass": "Collins Glass",
        "instructions": "Serve over ice- Warning,Deadly!",
        "ingredients": [
            "Bourbon",
            "Amaretto"
        ],
        "amounts": [
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 276,
        "name": "Godfather",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/r74uz51504368928.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour all ingredients directly into old fashioned glass filled with ice cubes. Stir gently.",
        "ingredients": [
            "Scotch",
            "Amaretto"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 277,
        "name": "Godmother",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/4889up1504368984.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour vodka and amaretto into an old-fashioned glass over ice and serve.",
        "ingredients": [
            "Vodka",
            "Amaretto"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 318,
        "name": "Jelly Bean",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/bglc6y1504388797.jpg",
        "glass": "Cordial glass",
        "instructions": "mix equal parts in pony glass-tastes just like a jelly bean!",
        "ingredients": [
            "Brandy",
            "Anisette"
        ],
        "amounts": [
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 473,
        "name": "Sol Y Sombra",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/3gz2vw1503425983.jpg",
        "glass": "Brandy snifter",
        "instructions": "Shake ingredients with ice, strain into a brandy snifter, and serve. (The English translation of the name of this drink is \"Sun and Shade\", and after sampling this drink, you'll understand why. Thanks, Kirby.)",
        "ingredients": [
            "Brandy",
            "Anisette"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 1/2 oz"
        ]
    },
    {
        "id": 92,
        "name": "Apple Grande",
        "type": "Punch / Party Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wqrptx1472668622.jpg",
        "glass": "Punch Bowl",
        "instructions": "Chill both ingredients!! Mix in a tumbler and enjoy!",
        "ingredients": [
            "Tequila",
            "Apple cider"
        ],
        "amounts": [
            "3 oz",
            "12 oz"
        ]
    },
    {
        "id": 536,
        "name": "Ziemes Martini Apfelsaft",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xnzr2p1485619687.jpg",
        "glass": "Collins Glass",
        "instructions": "Serve without ice. At least the juice shold have room temperature.",
        "ingredients": [
            "Vermouth",
            "Juice - Apple"
        ],
        "amounts": [
            "4 parts",
            "16 parts"
        ]
    },
    {
        "id": 95,
        "name": "Apple Slammer",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/09yd5f1493069852.jpg",
        "glass": "Shot glass",
        "instructions": "pour into a shot glass and present to consumer, they are expected to cover the top of the shotglass with thier palm, raise the glass, slam it on the bar and the swallow quickly.",
        "ingredients": [
            "Sprite",
            "Liqueur - Apple"
        ],
        "amounts": [
            "1 part",
            "1 part"
        ]
    },
    {
        "id": 122,
        "name": "Baby Guinness",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/rvyvxs1473482359.jpg",
        "glass": "Shot glass",
        "instructions": "Pour Kahlua, almost filling shot glass. Then, carefully pour Baileys, using wall of shot glass. This will give the \"Guinness\" its \"head\".",
        "ingredients": [
            "Kahlua",
            "Bailey's irish cream"
        ],
        "amounts": [
            "2 1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 325,
        "name": "Kentucky B And B",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/sqxsxp1478820236.jpg",
        "glass": "Brandy snifter",
        "instructions": "Pour the bourbon and Benedictine into a brandy snifter.",
        "ingredients": [
            "Bourbon",
            "Benedictine"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 413,
        "name": "Port Wine Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qruprq1441553976.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Port",
            "Brandy"
        ],
        "amounts": [
            "2 1/2 oz",
            "1/2 tsp"
        ]
    },
    {
        "id": 330,
        "name": "Kir Royale",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yt9i7n1504370388.jpg",
        "glass": "Champagne Flute",
        "instructions": "Pour Creme de cassis in glass, gently pour champagne on top",
        "ingredients": [
            "Liqueur - Raspberry",
            "Champagne"
        ],
        "amounts": [
            "1 part",
            "5 parts"
        ]
    },
    {
        "id": 517,
        "name": "Veteran",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/iwml9t1492976255.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour the rum and cherry brandy into an old-fashioned glass almost filled with ice cubes. Stir well.",
        "ingredients": [
            "Rum - Dark",
            "Brandy"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 9,
        "name": "410 Gone",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xtuyqv1472669026.jpg",
        "glass": "Collins Glass",
        "instructions": "",
        "ingredients": [
            "Vodka - Peach",
            "Coke"
        ],
        "amounts": [
            "2-3 oz"
        ]
    },
    {
        "id": 198,
        "name": "Citrus Coke",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/uyrvut1479473214.jpg",
        "glass": "Highball Glass",
        "instructions": "Pour half of coke in a glass. Then add rum and top it off with the remaining coke. Stir and drink up!",
        "ingredients": [
            "Rum - Light",
            "Coke"
        ],
        "amounts": [
            "1 part",
            "2 parts"
        ]
    },
    {
        "id": 491,
        "name": "Talos Coffee",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/rswqpy1441246518.jpg",
        "glass": "Brandy snifter",
        "instructions": "Add your GM and then add your coffee.",
        "ingredients": [
            "Triple Sec",
            "Coffee"
        ],
        "amounts": [
            "3 parts",
            "1 part"
        ]
    },
    {
        "id": 301,
        "name": "Iced Coffee Fillip",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/sxtxrp1454514223.jpg",
        "glass": "Coffee mug",
        "instructions": "Mix together in a coffee mug and chill before serving.",
        "ingredients": [
            "Kahlua",
            "Coffee"
        ],
        "amounts": [
            "2 tsp",
            "Strong cold"
        ]
    },
    {
        "id": 411,
        "name": "Poppy Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/cslw1w1504389915.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Gin",
            "Creme de Cacao"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz white"
        ]
    },
    {
        "id": 431,
        "name": "Royal Bitch",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/qupuyr1441210090.jpg",
        "glass": "Shot glass",
        "instructions": "Into a shot glass layer the Crown Royal on top of the Frangelico.",
        "ingredients": [
            "Frangelico",
            "Crown Royal"
        ],
        "amounts": [
            "1 part",
            "1 part"
        ]
    },
    {
        "id": 216,
        "name": "Danbooka",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/vurrxr1441246074.jpg",
        "glass": "Coffee Mug",
        "instructions": "pour it in and mix it.",
        "ingredients": [
            "Coffee",
            "Everpartsear"
        ],
        "amounts": [
            "3 parts",
            "1 part"
        ]
    },
    {
        "id": 404,
        "name": "Pink Gin",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qyr51e1504888618.jpg",
        "glass": "White wine glass",
        "instructions": "Pour the bitters into a wine glass. Swirl the glass to coat the inside with the bitters, shake out the excess. Pour the gin into the glass. Do not add ice.",
        "ingredients": [
            "Bitters",
            "Gin"
        ],
        "amounts": [
            "3 dashes",
            "2 oz"
        ]
    },
    {
        "id": 351,
        "name": "Lone Tree Cocktail",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/tsxpty1468923417.jpg",
        "glass": "Cocktail glass",
        "instructions": "Stir ingredients with ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Sweet Vermouth",
            "Gin"
        ],
        "amounts": [
            "3/4 oz",
            "1 1/2 oz"
        ]
    },
    {
        "id": 210,
        "name": "Cream Soda",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/yqstxr1479209367.jpg",
        "glass": "Highball glass",
        "instructions": "Pour 1oz of Spiced Rum into a highball glass with ice. Fill with Ginger Ale.",
        "ingredients": [
            "Rum - Spiced",
            "Ginger ale"
        ],
        "amounts": [
            "1 oz"
        ]
    },
    {
        "id": 218,
        "name": "Dark and Stormy",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/t1tn0s1504374905.jpg",
        "glass": "Highball glass",
        "instructions": "In a highball glass filled with ice add 6parts dark rum and top with ginger beer. Garnish with lime wedge.",
        "ingredients": [
            "Rum - Dark",
            "Ginger Beer"
        ],
        "amounts": [
            "5 parts",
            "10 parts"
        ]
    },
    {
        "id": 139,
        "name": "Big Red",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/yqwuwu1441248116.jpg",
        "glass": "Shot glass",
        "instructions": "Pour ingredients into 1 ounce shot glass",
        "ingredients": [
            "Irish cream",
            "Goldschlager"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 113,
        "name": "Auburn Headbanger",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/vw7iv91493067320.jpg",
        "glass": "Shot glass",
        "instructions": "Mix in spread glass over ice. Strain and pour in shot glass. Sit down before shotting. ENJOY!!",
        "ingredients": [
            "Jägermeister",
            "Goldschlager"
        ],
        "amounts": [
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 103,
        "name": "Arise My Love",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wyrrwv1441207432.jpg",
        "glass": "Champagne flute",
        "instructions": "Put creme de menthe into a champagne flute. Fill with chilled champagne and serve.",
        "ingredients": [
            "Champagne",
            "Green Creme de Menthe"
        ],
        "amounts": [
            "Chilled",
            "1 tsp"
        ]
    },
    {
        "id": 412,
        "name": "Port And Starboard",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/wxvupx1441553911.jpg",
        "glass": "Pousse cafe glass",
        "instructions": "Pour carefully into a pousse-cafe glass, so that creme de menthe floats on grenadine. Serve without mixing.",
        "ingredients": [
            "Grenadine",
            "Green Creme de Menthe"
        ],
        "amounts": [
            "1 tblsp",
            "1/2 oz"
        ]
    },
    {
        "id": 215,
        "name": "Damned if you do",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/ql7bmx1503565106.jpg",
        "glass": "Shot glass",
        "instructions": "Pour into shot glass. Put in mouth. Repeat as deemed necessary.",
        "ingredients": [
            "Whiskey",
            "Hot Damn"
        ],
        "amounts": [
            "0.75 oz",
            "0.25 oz"
        ]
    },
    {
        "id": 105,
        "name": "Arizona Stingers",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/y7w0721493068255.jpg",
        "glass": "Hurricane glass",
        "instructions": "Place ice cubes in the hurricane glass . Add the 2 HEAPING shots of Absolute Vodka (Note: You can add as many shots of Absolute as you want!) Fill the rest of glass with the Arizona Icetea with lemon. Stir to mix using a spoon. Drink up and enjoy!!!!!!!",
        "ingredients": [
            "Vodka",
            "Iced tea"
        ],
        "amounts": [
            "2 shots",
            "12 oz lemon"
        ]
    },
    {
        "id": 334,
        "name": "Kool First Aid",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/hfp6sv1503564824.jpg",
        "glass": "Shot glass",
        "instructions": "Add Kool Aid to a double shot glass, and top with rum. Slam and shoot.",
        "ingredients": [
            "Rum - Strong",
            "Kool-Aid"
        ],
        "amounts": [
            "2 oz light",
            "1/2 tsp Tropical"
        ]
    },
    {
        "id": 73,
        "name": "Amaretto And Cream",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/dj8n0r1504375018.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake well with cracked ice, strain contents into a cocktail glass, and serve.",
        "ingredients": [
            "Amaretto",
            "Cream"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 1/2 oz"
        ]
    },
    {
        "id": 75,
        "name": "Amaretto Mist",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/utpxxq1483388370.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour amaretto in an old-fashioned glass over crushed ice. Add the wedge of lime and serve. (A wedge of lemon may be substituted for lime, if preferred.)",
        "ingredients": [
            "Amaretto",
            "Lime"
        ],
        "amounts": [
            "1 1/2 oz"
        ]
    },
    {
        "id": 490,
        "name": "Sweet Tooth",
        "type": "Milk / Float / Shake",
        "image": "http://www.thecocktaildb.com/images/media/drink/j6rq6h1503563821.jpg",
        "glass": "Highball Glass",
        "instructions": "Put 2 shots Godiva Liquour into a glass, add as much or as little milk as you would like.",
        "ingredients": [
            "Liqueur - White Chocolate",
            "Milk"
        ],
        "amounts": [
            "2 shots"
        ]
    },
    {
        "id": 424,
        "name": "Quick-sand",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vprxqv1478963533.jpg",
        "glass": "Highball glass",
        "instructions": "Simply add the orange juice, quite a quick pour in order to mix the sambucca with the orange juice. The juice MUST have fruit pulp!",
        "ingredients": [
            "Black Sambuca",
            "Juice - Orange"
        ],
        "amounts": [
            "25 ml",
            "Add 250 ml"
        ]
    },
    {
        "id": 373,
        "name": "Mimosa",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/juhcuu1504370685.jpg",
        "glass": "Champagne flute",
        "instructions": "Ensure both ingredients are well chilled, then mix into the glass. Serve cold.",
        "ingredients": [
            "Champagne",
            "Juice - Orange"
        ],
        "amounts": [
            "Chilled",
            "2 oz"
        ]
    },
    {
        "id": 457,
        "name": "Screwdriver",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/8xnyke1504352207.jpg",
        "glass": "Highball glass",
        "instructions": "Mix in a highball glass with ice. Garnish and serve.",
        "ingredients": [
            "Vodka",
            "Juice - Orange"
        ],
        "amounts": [
            "2 oz"
        ]
    },
    {
        "id": 544,
        "name": "Zorbatini",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/wtkqgb1485621155.jpg",
        "glass": "Cocktail glass",
        "instructions": "Prepare like a Martini. Garnish with a green olive.",
        "ingredients": [
            "Vodka",
            "Ouzo"
        ],
        "amounts": [
            "1 1/4 oz Stoli",
            "1/4 oz"
        ]
    },
    {
        "id": 133,
        "name": "Bellini",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/eaag491504367543.jpg",
        "glass": "Champagne Flute",
        "instructions": "Pour peach purée into chilled flute, add sparkling wine. Stir gently.",
        "ingredients": [
            "Champagne",
            "Peach schnapps"
        ],
        "amounts": [
            "6 oz",
            "1 oz"
        ]
    },
    {
        "id": 257,
        "name": "Fuzzy Asshole",
        "type": "Coffee / Tea",
        "image": "http://www.thecocktaildb.com/images/media/drink/wrvpuu1472667898.jpg",
        "glass": "Coffee mug",
        "instructions": "fill coffe mug half full of coffee. Fill the other half full of Peach Schnapps. Stir and drink while hot.",
        "ingredients": [
            "Coffee",
            "Peach schnapps"
        ],
        "amounts": [
            "1/2",
            "1/2"
        ]
    },
    {
        "id": 535,
        "name": "Zenmeister",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/qyuvsu1479209462.jpg",
        "glass": "Collins Glass",
        "instructions": "Mix together and enjoy",
        "ingredients": [
            "Jägermeister",
            "Root beer"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 240,
        "name": "Flander's Flake-Out",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/sqvqrx1461866705.jpg",
        "glass": "Collins Glass",
        "instructions": "Bang 'em both in.",
        "ingredients": [
            "Sambuca",
            "Sarsaparilla"
        ],
        "amounts": [
            "1/4 glass",
            "3/4 glass"
        ]
    },
    {
        "id": 523,
        "name": "Vodka Russian",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/rpttur1454515129.jpg",
        "glass": "Collins Glass",
        "instructions": "Mix it as a ordinary drink .",
        "ingredients": [
            "Vodka",
            "Schweppes Russchian"
        ],
        "amounts": [
            "2 oz"
        ]
    },
    {
        "id": 78,
        "name": "Amaretto Sour",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/xnzc541493070211.jpg",
        "glass": "Collins Glass",
        "instructions": "Shake and strain. Garnish with a cherry and an orange slice.",
        "ingredients": [
            "Amaretto",
            "Sour mix"
        ],
        "amounts": [
            "1 1/2 oz",
            "3 oz"
        ]
    },
    {
        "id": 539,
        "name": "Zinger",
        "type": "Soft Drink / Soda",
        "image": "http://www.thecocktaildb.com/images/media/drink/iixv4l1485620014.jpg",
        "glass": "Highball glass",
        "instructions": "Get a shot glass and pour in three shots of the schnapps. Do the same with the Surge Cola. Then down it like Scheetz would.",
        "ingredients": [
            "Liqueur - Peach",
            "Energy Drink"
        ],
        "amounts": [
            "4 shots",
            "4 shots"
        ]
    },
    {
        "id": 171,
        "name": "Brave Bull Shooter",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/yrtypx1473344625.jpg",
        "glass": "Shot glass",
        "instructions": "Pour Tabasco into bottom of shot glass and fill with tequila.",
        "ingredients": [
            "Tequila",
            "Tabasco"
        ],
        "amounts": [
            "1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 496,
        "name": "Tequila Surprise",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/8189p51504735581.jpg",
        "glass": "Shot glass",
        "instructions": "Fill shot glass with Tequila. Add drops of Tobasco sauce.",
        "ingredients": [
            "Tequila",
            "Tabasco"
        ],
        "amounts": [
            "full glass",
            "About 8 drops"
        ]
    },
    {
        "id": 356,
        "name": "Lord And Lady",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/quwrys1468923219.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour the rum and Tia Maria into an old-fashioned glass almost filled with ice cubes. Stir well.",
        "ingredients": [
            "Rum - Dark",
            "Tia maria"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 520,
        "name": "Vodka And Tonic",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/lmj2yt1504820500.jpg",
        "glass": "Highball glass",
        "instructions": "Pour vodka into a highball glass over ice cubes. Fill with tonic water, stir, and serve.",
        "ingredients": [
            "Vodka",
            "Water - Tonic"
        ],
        "amounts": [
            "2 oz"
        ]
    },
    {
        "id": 241,
        "name": "Flying Dutchman",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/akik8t1504519958.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "In an old-fashioned glass almost filled with ice cubes, combine the gin and triple sec. Stir well.",
        "ingredients": [
            "Gin",
            "Triple Sec"
        ],
        "amounts": [
            "2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 48,
        "name": "Addison",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/yzva7x1504820300.jpg",
        "glass": "Martini Glass",
        "instructions": "Shake together all the ingredients and strain into a cold glass.",
        "ingredients": [
            "Gin",
            "Vermouth"
        ],
        "amounts": [
            "1 1/2 shot",
            "1 1/2 shot"
        ]
    },
    {
        "id": 0,
        "name": "57 Chevy with a White License Plate",
        "type": "Cocktail",
        "image": "http://www.thecocktaildb.com/images/media/drink/qyyvtu1468878544.jpg",
        "glass": "Highball glass",
        "instructions": "1. Fill a rocks glass with ice 2.add white creme de cacao and vodka 3.stir",
        "ingredients": [
            "Creme de Cacao",
            "Vodka"
        ],
        "amounts": [
            "1 oz",
            "1 oz"
        ]
    },
    {
        "id": 336,
        "name": "Kool-Aid Slammer",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/kugu2m1504735473.jpg",
        "glass": "Shot glass",
        "instructions": "Fill half the shot glass with the kool-aid first. Then put a paper towel over the top of the glass and slowly pour in the vodka. If you do it right, you should be able to see that the two liquids are separated, with the vodka on top. Now slam it! The last thing you'll taste is the kool-aid.",
        "ingredients": [
            "Kool-Aid",
            "Vodka"
        ],
        "amounts": [
            "1/2 oz Grape",
            "1/2 oz"
        ]
    },
    {
        "id": 142,
        "name": "Black Russian",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/2k5gbb1504367689.jpg",
        "glass": "Old-fashioned glass",
        "instructions": "Pour the ingredients into an old fashioned glass filled with ice cubes. Stir gently.",
        "ingredients": [
            "Liqueur - Coffee",
            "Vodka"
        ],
        "amounts": [
            "3/4 oz",
            "1 1/2 oz"
        ]
    },
    {
        "id": 79,
        "name": "Amaretto Stinger",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/vvop4w1493069934.jpg",
        "glass": "Cocktail glass",
        "instructions": "Shake ingredients well with cracked ice, strain into a cocktail glass, and serve.",
        "ingredients": [
            "Amaretto",
            "White Creme de Menthe"
        ],
        "amounts": [
            "1 1/2 oz",
            "3/4 oz"
        ]
    },
    {
        "id": 479,
        "name": "Stinger",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/2ahv791504352433.jpg",
        "glass": "Cocktail glass",
        "instructions": "Pour in a mixing glass with ice, stir and strain into a cocktail glass. May also be served on rocks in a rocks glass.",
        "ingredients": [
            "Brandy",
            "White Creme de Menthe"
        ],
        "amounts": [
            "1 1/2 oz",
            "1/2 oz"
        ]
    },
    {
        "id": 6,
        "name": 252,
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/rtpxqw1468877562.jpg",
        "glass": "Shot glass",
        "instructions": "Add both ingredients to shot glass, shoot, and get drunk quick",
        "ingredients": [
            "Rum - Strong",
            "Bourbon"
        ],
        "amounts": [
            "1/2 shot",
            "1/2 shot"
        ]
    },
    {
        "id": 27,
        "name": "ACID",
        "type": "Shot",
        "image": "http://www.thecocktaildb.com/images/media/drink/xuxpxt1479209317.jpg",
        "glass": "Shot glass",
        "instructions": "Poor in the 151 first followed by the 101 served with a Coke or Dr Pepper chaser.",
        "ingredients": [
            "Rum - Strong",
            "Bourbon"
        ],
        "amounts": [
            "1 oz ",
            "1 oz"
        ]
    },
    {
        "id": 526,
        "name": "Whisky Mac",
        "type": "Ordinary Drink",
        "image": "http://www.thecocktaildb.com/images/media/drink/yvvwys1461867858.jpg",
        "glass": "Collins Glass",
        "instructions": "Pour both of the ingredients into a wine goblet with no ice.",
        "ingredients": [
            "Scotch",
            "Wine"
        ],
        "amounts": [
            "1 1/2 oz",
            "1 oz Green Ginger"
        ]
    }
]

export default cocktailList